import { useLocation, useNavigationType, useParams } from "react-router-dom";
import { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import Loading from 'react-loading';
//images ;
import p_down_arrow_circle from '../../Assets/Images/booking/p_down_arrow_circle.svg';
import p_up_arrow_circle from '../../Assets/Images/booking/p_up_arrow_circle.svg';
import p_history_icon from '../../Assets/Images/booking/p_history_icon.svg';
import p_call from '../../Assets/Images/booking/p_call.svg';
import p_text_message from '../../Assets/Images/booking/p_text_message.svg';
import p_share from '../../Assets/Images/booking/p_share.svg';
import p_nav_previous from '../../Assets/Images/p_nav_previous.svg';
import { FaExclamation } from "react-icons/fa";

import VerticalStepper from '../../Components/stepper';
import DownLossdbillingPDF from '../../Components/downloadBillingPDF';

import { FaAngleDown } from "react-icons/fa6";
import { FaAngleUp } from "react-icons/fa6";

import { GoChevronRight } from "react-icons/go";
//firebase
import { getDatabase, ref, onValue } from "firebase/database";
import { database } from "../../Services/firebase-service/firebase";
//Stopwatch
import { acceptRescheduleRequest, cancelRescheduleRequest, getBookingDetails } from "../../Services/api";
import Stopwatch from "../../Components/Stopwatch";
import axiosInstance, { Razorpay_Key } from "../../Services/axios";
import { useUser } from '../../Components/UserContext'; // Adjust the path according to your file structure
import AppointmentCancelled from '../../Assets/Images/Appointment.jpg';
import { IoIosStarOutline } from "react-icons/io";
import { IoMdStar } from "react-icons/io";
import { toast } from 'react-toastify';
import Lottie from "lottie-react";
import SuccessLotie from "./../../Assets/lottieFiles/success.json";
import useRazorpay from "react-razorpay";
import { IoMdHome } from "react-icons/io";
import { IoLocationSharp } from "react-icons/io5";
import { MdWork } from "react-icons/md";
import bell_icon from "../../Assets/Images/icons/bell_icon.png"
import Avoid_call from "../../Assets/Images/icons/avoid_call_icon.png"
import pet_foot from "../../Assets/Images/icons/pet_foot_icon.png"
import { showToast } from "../../Components/toastConfig/ToastConfig";
import { IoCloseSharp } from "react-icons/io5";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import door_icon from "../../Assets/Images/icons/door_icon.png"
import thankyouLottie from "./../../Assets/lottieFiles/thankyou.json"
import { IoMdClose } from "react-icons/io";
import { AudioRecorder, useAudioRecorder } from 'react-audio-voice-recorder';
import { FaPlay } from "react-icons/fa";
import { FaPause, FaStop } from "react-icons/fa6";
import { MdDeleteOutline } from "react-icons/md";
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { IoSend } from "react-icons/io5";
import { MdEditDocument } from "react-icons/md";
import NodeaxiosInstance from "../../Services/nodeaxios";

const UserBookingDetails = () => {

    const location = useLocation();
    const { fromPage } = location.state || {};


    const ref1 = useRef();
    const rescheduleModalRef = useRef(null);
    const rescheduleRequestModalRef = useRef(null);
    const instructionsNoteRef = useRef(null)

    const cancelrefundModalRef = useRef(null);
    const cancelConfirmModalRef = useRef(null);
    const payBalancerequestModal = useRef(null);
    const cancelBalanceRequestModalRef = useRef(null);
    const paymentSuccessModalRef = useRef(null);
    const canceldisputeModalRef = useRef(null);
    const editOrderModalRef = useRef(null);
    const cancelOrderConfirmModalRef = useRef(null)
    const feedbacksuccessModalRef = useRef(null)
    const audioRef = useRef(null)
    const timerRef = useRef(null);

    const [Razorpay] = useRazorpay();
    const currentUser = useUser();
    const params = useParams();


    const [booking_id, setBooking_id] = useState(params.id)

    const navigate = useNavigate();
    const [startTimer, setStartTimer] = useState(false)
    const [record, setRecord] = useState([]);
    const [paymenttype, setPaymenttype] = useState()
    const [paymentdetail, setPaymentdetail] = useState('')
    const [showMoreInforUser, setShowMoreInforUser] = useState(false);
    const [showMoreInforStaff, setShowMoreInforStaff] = useState(false);
    const [buttonClicked, setButtonClicked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [deliverystep, setDeliverystep] = useState([]);
    const [vendor_id, setVendorId] = useState()
    const [refund, setRefund] = useState([])
    const [dispute, setDispute] = useState()
    const [appointmentRescheduled, setAppointmentRescheduled] = useState(false);
    const [vendor_subscription_status, setVendor_subscription_status] = useState(false);
    const [bookingstatus, setBookingstatus] = useState(0);
    const [storeActiveStep, setStoreActiveStep] = useState('');
    const [doorActiveStep, setDoorActiveStep] = useState('');
    const [activeTab, setActiveTab] = useState("Ticket");
    const [ratings, setRatings] = useState([false, false, false, false, false]);
    const [feedback, setFeedback] = useState('')
    const [ratecount, setRatecount] = useState('')
    const [paymentOrderId, setPaymentOrderId] = useState();
    const [copied, setCopied] = useState(false);
    const [cancelConfirmModal, setCancelConfirmModal] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [instructionsOption, setInstructionsOption] = useState([])
    const [selectedTexts, setSelectedTexts] = useState("")
    const [rescheduleMessage, setRescheduleMessage] = useState('');
    const [rescheduleModeltype, setRescheduleModeltype] = useState('');
    const [pageLoaded, setPageLoaded] = useState(false);
    const [recordedAudio, setRecordedAudio] = useState(null);
    const [pauseicon, setPauseicon] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const [audioDuration, setAudioDuration] = useState(0);
    const [restartRecord, setRestartRecord] = useState(true);
    const [recordedAudioUrl, setRecordedAudioUrl] = useState(null);
    const [oldrecordedAudioblob, setOldRecordedAudioblob] = useState(null);
    const [recordedDataUrl, setRecordedDataUrl] = useState(null);
    const [recordingTime, setRecordingTime] = useState(0);
    const [consulation, setConsulation] = useState("");
    // chips, note text and voice note as last saved on the server (used to decide when the Send button shows)
    const savedInstructionsRef = useRef([]);
    const savedNoteRef = useRef('');
    const savedVoiceRef = useRef('');
    // always points at the latest handleSendInstructions (deleteRecordedAudio is memoized and would otherwise call a stale copy)
    const sendInstructionsRef = useRef(null);
    const [playTime, setPlayTime] = useState(0);
    const [oldRecordurl, setOldRecordurl] = useState('')
    const [isChanged, setIsChanged] = useState(false)
    const [instructionisLoading, setInstructionIsLoading] = useState(false);
    const [isinstructionModalOpen, setIsinstructionModalOpen] = useState(false)
    const [editRateing, setEditRateing] = useState(false)

    

    useEffect(() => {
        if (!currentUser) return;
        const database = getDatabase();
        const orderRef = ref(database, `/bookings/${booking_id}`);
        const unsubscribe = onValue(orderRef, snapshot => {
            const data = snapshot.val();
            if (data) {
                // getproductDetails();
                loadBookingDetails()

            }
        });

        return () => unsubscribe(); // Detach listener on cleanup
    }, [currentUser, booking_id]);

    useEffect(() => {
        if (paymentdetail?.balence_request?.request_status == 1 && paymentdetail?.payment_status == "0") {
            openBalancerequestModal()
        }
    }, [paymentdetail]);

    useEffect(() => {

        loadBookingDetails();
        try {
            const starCountRef = ref(database, `bookings/${booking_id}`);
            onValue(starCountRef, (snapshot) => {
                const data = snapshot.val();
                if (!!data) {

                    loadBookingDetails();
                    if (data == 4) {
                        setStartTimer(true)
                    }

                } else {
                }
            })
        } catch (error) {
            console.log('error,', error);
        }
    }, [booking_id]);


    const loadBookingDetails = () => {
        let body = {
            booking_id: booking_id
        };
        getBookingDetails(body).then((res) => {

            let data = res.data;

            setRecord(res.data);
            // record?.reschedule_detail?.by == '2'
            if (data.reschedule_status == '1' && (data.reschedule_detail?.by == '2' || data.reschedule_detail?.by == '1')) {
                openrescheduleRequestModal()
                setIsModalOpen(true)
            } else {
                closerescheduleRequestModal()
            }

            fixAndParse(data?.note_details?.note_desc)



            if (data?.booking_details?.edit_booking_status == "1" && data?.booking_details?.edit_booking_detail?.request_status == "1") {
                openEditorderModal()
                setIsModalOpen(true)
            }
            setPaymenttype(res.data.booking_details.payment_method)
            setVendorId(res.data.book_staff.vendor_id)


            setPaymentdetail(res.data.booking_details?.payment_details)
            if (data.booking_details?.payment_details?.balence_request?.request_status == 1 && data.booking_details?.payment_details?.payment_status == "0") {
                openBalancerequestModal()
            }
            if (Array.isArray(res.data.doorstep_que_detail)) {
                setDeliverystep(res.data.doorstep_que_detail);
            }

            if (Number(data?.reschedule_status) == 1 && Number(data?.doorstep_que_status) == 6 && data?.vendor_subscription_status == 1) {
                setAppointmentRescheduled(true);
            } else {
                setAppointmentRescheduled(false);
            }
            setVendor_subscription_status(data?.vendor_subscription_status);
            setBookingstatus(Number(data?.booking_details.book_status));

            if (Number(data?.book_service_type) == 1) {
                setStoreActiveStep(Number(data?.booking_details?.book_que_status));
                //  Doorstep Booking Que status
            } else if (Number(data?.book_service_type) == 2) {

                if (Number(data?.doorstep_que_status) == 1) {
                    setDoorActiveStep(1);
                    setActiveTab('Schedule')
                } else if (Number(data?.doorstep_que_status) == 2) {
                    setActiveTab('Schedule')
                    setDoorActiveStep(2);
                } else if (Number(data?.doorstep_que_status) == 3) {
                    setDoorActiveStep(3);


                } else if (Number(data?.doorstep_que_status) == 4) {
                    setDoorActiveStep(4);
                    // setBookingStartDateTime(data?.booking_details.bookstartdatetime);
                } else if (Number(data?.doorstep_que_status) == 5) {
                    setDoorActiveStep(5);
                } else if (Number(data?.doorstep_que_status) == 6) {
                    setDoorActiveStep(6);
                    setActiveTab('Schedule')
                }
            }

            if (data?.rate_status == '1') {
                handleStarClick(data?.rate_details?.rate_count ? Number(data?.rate_details?.rate_count) - 1 : 0);
                setFeedback(data?.rate_details?.rate_desc);
            }

            setPageLoaded(true)
        });
    }


    function fixAndParse(noteDesc) {
        if (!noteDesc || typeof noteDesc !== "string") return {};

        let fixed = noteDesc.trim();

        if (/\"voice_note\":\"[^\"]*$/.test(fixed)) {
            fixed += "\"";
        }

        if (!fixed.endsWith("}")) {
            fixed += "}";
        }

        try {
            const parsed = JSON.parse(fixed);

            setConsulation(parsed.additional_notes);
            setInstructionsOption(parsed.delivery_instructions || []);
            savedInstructionsRef.current = parsed.delivery_instructions || [];
            savedNoteRef.current = parsed.additional_notes || '';
            savedVoiceRef.current = parsed.voice_note || '';

            if (parsed.voice_note) {
                const audio = new Audio(parsed.voice_note);
                audioRef.current = audio;
                audioRef.current.onended = () => setIsPlaying(false);

                audio.onloadedmetadata = () => {
                    const duration = audio.duration;
                    setRecordingTime(duration);
                };
                setOldRecordurl(parsed.voice_note)
                setRestartRecord(false);
                setRecordedAudioUrl(parsed.voice_note);
                setRecordedAudio(parsed.voice_note);
            } else {
                // no voice note saved: drop any stale URL so it is never sent again
                setOldRecordurl(null);
            }

            return parsed;

        } catch (err) {
            console.error("Failed to parse even after fixing:", err.message, fixed);
            return {};
        }
    }



    const acceptRejectReschedule = (type) => {
        try {
            let body = {
                booking_id: booking_id,
                vendor_id: vendor_id,
            };

            if (type == 1) {
                setIsLoading(true)

                acceptRescheduleRequest(body).then((res) => {
                    closerescheduleRequestModal();

                    setRescheduleMessage("Reschedule confirmed. Your booking has been updated.");
                    loadBookingDetails();
                    openrescheduleModal(2)
                    setIsModalOpen(true);
                    setIsLoading(false)
                });
            } else if (type == 2) {
                cancelRescheduleRequest(body).then((res) => {
                    closerescheduleRequestModal();

                    setRescheduleMessage(
                        "Reschedule request declined. Your booking is confirmed as originally scheduled."
                    );
                    loadBookingDetails();
                    openrescheduleModal(2)

                    setIsModalOpen(true);
                    // setIsLoading(false)

                });
            }
        } catch (error) {
            setIsLoading(false)

            if (error.response) {
                if (error.response.status == 400) {
                    toast.error("Bad request. Please check your input.");
                } else if (error.response.status === 500) {
                    toast.error("Server error. Please try again later.");
                } else {
                    toast.error(`Error: ${error.response.statusText}`);
                }

            } else if (error.request) {
                toast.error("No response from server. Check your internet connection.");
            } else {
                toast.error("Something went wrong.");
            }
        }
    };

    //Calling the child component functions


    const getRefundInfo = async () => {
        try {
            const reqData = {
                booking_id: booking_id,
            };

            const response = await NodeaxiosInstance.post('service/get-refund-info', reqData);
            if (response.status == 200) {
                const data = response?.data

                setIsModalOpen(true)
                cancelrefundModalRef.current.classList.add('show');
                cancelrefundModalRef.current.style.display = 'block';
                setRefund(data)
                // setCancelBalanceRequestModal(false)

            }
        } catch (error) {

            if (error.response) {
                if (error.response.status == 400) {
                    toast.error("Bad request. Please check your input.");
                } else if (error.response.status == 500) {
                    toast.error("Server error. Please try again later.");
                } else {
                    toast.error(`Error: ${error.response.statusText}`);
                }
            } else if (error.request) {

                toast.error("No response from server. Check your internet connection.");
            } else {

                toast.error("Something went wrong.");
            }

        }
    }

    const cancelBooking = async () => {
        try {
            const reqData = {
                booking_id: booking_id,
            };

            setLoading(true);
            setButtonClicked(true);
            const response = await NodeaxiosInstance.post('service/confirm-cancel-booking', reqData);
            if (response.status == 200) {
                const data = response?.data
                cancelrefundModalRef.current.classList.remove('show');
                cancelConfirmModalRef.current.classList.add('show');
                cancelConfirmModalRef.current.style.display = 'block';
                setIsModalOpen(false)
                setLoading(false);
                setButtonClicked(false);
            }
        } catch (error) {

            if (error.response) {
                if (error.response.status == 400) {
                    toast.error("Bad request. Please check your input.");
                } else if (error.response.status == 500) {
                    toast.error("Server error. Please try again later.");
                } else {
                    toast.error(`Error: ${error.response.statusText}`);
                }
            } else if (error.request) {

                toast.error("No response from server. Check your internet connection.");
            } else {

                toast.error("Something went wrong.");
            }

        }
    }

    const cancelEditBookingRequest = () => {
        try {
            const reqData = {
                booking_id: booking_id,
            };


            NodeaxiosInstance.post("service/cancel-edit-service-request", reqData)
                .then((res) => {

                    closeEditorderModal()
                }).catch((err) => {
                    if (err.response.status == 400 || err.response.status == 500) {
                        toast(err.response.data.message, {
                            position: "bottom-center",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                            className: "text-danger toast-style-1",
                        });
                    }
                });
        } catch (error) {

            if (error.response) {
                if (error.response.status == 400) {
                    toast.error("Bad request. Please check your input.");
                } else if (error.response.status == 500) {
                    toast.error("Server error. Please try again later.");
                } else {
                    toast.error(`Error: ${error.response.statusText}`);
                }
            } else if (error.request) {

                toast.error("No response from server. Check your internet connection.");
            } else {

                toast.error("Something went wrong.");
            }

        }
    };

    const [expanded, setExpanded] = useState(false);

    const toggleExpanded = () => {
        setExpanded(!expanded);
    };

    useEffect(() => {
        const addressElement = document.getElementById("Address");
        if (addressElement) {
            const addressText = addressElement.textContent;
            if (addressText.length > 27) {
                addressElement.textContent = addressText.slice(0, 27) + "...";
            }
        }
    }, []);



    const confirmReschedule = () => {
        let serviceDetail = {
            serviceType: record?.book_service_type,
            vendorId: record?.vendor_id,
            cart_app_id: record?.book_id,
            reschedule: true
        }

        let cardDetail = {
            cardStatus: "",
            cardType: "",
            cardId: "",
        }

        localStorage.setItem('serviceDetail', JSON.stringify(serviceDetail));
        localStorage.setItem('appliedCard', JSON.stringify(cardDetail));
        localStorage.setItem('selectedServiceOption', 'service');
        closerescheduleModal()
        navigate(`/select-staff/${record.vendor_id}`)
    }

    const openrescheduleModal = (type) => {
        setRescheduleModeltype(type)
        rescheduleModalRef.current.classList.add("show");
        rescheduleModalRef.current.style.display = "block";
    };

    const closerescheduleModal = () => {
        rescheduleModalRef.current.classList.remove("show");
        rescheduleModalRef.current.style.display = "none";
    };

    const closecancelrefundModalRef = () => {
        setIsModalOpen(false)
        cancelrefundModalRef.current.classList.remove("show");
        cancelrefundModalRef.current.style.display = "none";

    };

    const handleOkClick = () => {
        cancelConfirmModalRef.current.classList.remove("show");
        cancelConfirmModalRef.current.style.display = "none";
    };

    const openBalancerequestModal = () => {
        if (payBalancerequestModal.current) {
            payBalancerequestModal.current.classList.add("show");
            payBalancerequestModal.current.style.display = "block";
            setIsModalOpen(true)
        }
    }


    const closeBalancerequestModal = () => {
        if (payBalancerequestModal.current) {
            payBalancerequestModal.current.classList.remove("show");
            payBalancerequestModal.current.style.display = "none";
            setIsModalOpen(false)
        }
    }

    const openrescheduleRequestModal = () => {

        if (rescheduleRequestModalRef.current) {
            rescheduleRequestModalRef.current.classList.add("show");
            rescheduleRequestModalRef.current.style.display = "block";
            setIsModalOpen(true)
        }
    }


    const closerescheduleRequestModal = () => {
        if (rescheduleRequestModalRef.current) {
            rescheduleRequestModalRef.current.classList.remove("show");
            rescheduleRequestModalRef.current.style.display = "none";
            setIsModalOpen(false)
        }
    }

    const openEditorderModal = () => {
        if (editOrderModalRef.current) {
            editOrderModalRef.current.classList.add("show");
            editOrderModalRef.current.style.display = "block";
        }
        setIsModalOpen(true)
    };

    const closeEditorderModal = () => {
        if (editOrderModalRef.current) {
            editOrderModalRef.current.classList.remove("show");
            editOrderModalRef.current.style.display = "none";
            setIsModalOpen(false)
        }
    };
    const opencancelOrderModal = () => {
        cancelOrderConfirmModalRef.current.classList.add("show");
        cancelOrderConfirmModalRef.current.style.display = "block";
        setCancelConfirmModal(true)
    };

    const closecancelOrderModal = () => {
        cancelOrderConfirmModalRef.current.classList.remove("show");
        cancelOrderConfirmModalRef.current.style.display = "none";
        setCancelConfirmModal(false)
    };

    const openfeedbacksuccessModal = () => {
        feedbacksuccessModalRef.current.classList.add("show");
        feedbacksuccessModalRef.current.style.display = "block";
        setCancelConfirmModal(true)
    };

    const closefeedbacksuccessModal = () => {
        feedbacksuccessModalRef.current.classList.remove("show");
        feedbacksuccessModalRef.current.style.display = "none";
        setCancelConfirmModal(false)
    };

    const openinstructionsModal = () => {
        instructionsNoteRef.current.classList.add("show");
        instructionsNoteRef.current.style.display = "block";
        setIsinstructionModalOpen(true)
    };
    const closeinstructionsModal = () => {
        instructionsNoteRef.current.classList.remove("show");
        instructionsNoteRef.current.style.display = "none";
        setIsinstructionModalOpen(false)

    };


    const handleStarClick = (index) => {
        const newRatings = [...ratings];
        for (let i = 0; i < newRatings.length; i++) {
            if (i <= index) {
                newRatings[i] = true;

            } else {
                newRatings[i] = false;
            }
        }
        setRatings(newRatings);
        setRatecount(index + 1)
    };


    const starRating = () => {
        try {
            // if (!ratecount && !feedback) {
            //     showToast('Kindly share your rating and feedback to continue.');
            //     return;
            // }


            if (record.rate_status == 1) {
                const reqData = {
                    user_id: record.user_id,
                    rate_id: record.rate_details.rate_id,
                    rate_count: ratecount == 0 ? 1 : ratecount,
                    rate_desc: feedback,
                };
                NodeaxiosInstance.post('service/update-rate-details', reqData)
                    .then((res) => {
                        setEditRateing(false)
                        toast("Rating has been submitted.", {
                            position: "bottom-center",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                            className: "text-success toast-style-1",
                        });
                    });
            } else if (record.rate_status == 0) {
                const reqData = {
                    user_id: record.user_id,
                    booking_id: booking_id,
                    vendor_id: record.vendor_id,
                    rate_count: ratecount == 0 ? 1 : ratecount,
                    rate_desc: feedback,
                };

                NodeaxiosInstance.post('service/add-rate-details', reqData)
                    .then((res) => {
                        setEditRateing(false)
                        toast("Rating has been submitted.", {
                            position: "bottom-center",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                            className: "text-success toast-style-1",
                        });
                    });
            }
        } catch (error) {

            const errorMessage = error.response.message || "An error occurred.";
            toast(errorMessage, {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                className: 'text-danger toast-style-1'
            });
        }
    };

    const payBalance = () => {
        let userDetatil = {
            name: "",
            phone: "",
            email: "",
        };

        setPaymentOrderId(paymentdetail?.balence_request?.order_id);

        handlePayment(userDetatil, paymentdetail?.balence_request.order);
    }


    const handlePayment = useCallback(
        (userData, orderData) => {
            const createOrderAndInitializePayment = async () => {
                const options = {
                    key: Razorpay_Key,
                    amount: orderData.amount,
                    currency: orderData.currency,
                    name: "PINGLE",
                    description: "Payment",
                    image: "https://pingle.in/user/assets/images/LogoUser.png",
                    order_id: orderData.id,
                    handler: (res) => {


                        if (res) {
                            loadBookingDetails()

                            openPaymentSuccessModal()
                            setIsModalOpen(true)
                            // onPayment(res); // Passing the order ID to the parent component
                            //
                        }
                    },
                    prefill: {
                        name: userData.name,
                        email: userData.email,
                        contact: userData.phone,
                    },
                    theme: {
                        color: "#4E26A3",
                    },
                };

                const rzpay = new Razorpay(options);
                rzpay.open();
            };

            createOrderAndInitializePayment();
        },
        [Razorpay]
    );

    const cancelBalanceRequest = () => {
        try {
            setIsLoading(true)
            const reqData = {
                booking_id: record.book_id,
            };

            NodeaxiosInstance.post('service/reject-balance-payment-request', reqData)
                .then((res) => {
                    loadBookingDetails()
                    closeBalancerequestModal()
                    closeCancelBalanceRequestModal()
                    setIsLoading(false)
                })
        } catch (error) {
            const errorMessage = error.response.data?.message || "An error occurred.";
            toast(errorMessage, {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                className: 'text-danger toast-style-1'
            });

        }
    }

    const openPaymentSuccessModal = () => {
        // setIsModalOpen(true)
        closeBalancerequestModal()
        paymentSuccessModalRef.current.classList.add('show');
        paymentSuccessModalRef.current.style.display = 'block';
    };

    const handleSuccessOkClick = () => {
        setIsModalOpen(false)
        paymentSuccessModalRef.current.classList.remove('show');
        paymentSuccessModalRef.current.style.display = 'none';
    };

    const openCancelBalanceRequestModal = () => {
        setIsModalOpen(true)
        if (cancelBalanceRequestModalRef.current) {
            cancelBalanceRequestModalRef.current.classList.add('show');
            cancelBalanceRequestModalRef.current.style.display = 'block';
        }
    }

    const closeCancelBalanceRequestModal = () => {

        if (cancelBalanceRequestModalRef.current) {
            cancelBalanceRequestModalRef.current.classList.remove('show');
            cancelBalanceRequestModalRef.current.style.display = 'none';
        }
    }
    const copyToClipboard = () => {
        const textToCopy = record.profile_merchant_share_url;

        const textarea = document.createElement('textarea');
        textarea.value = textToCopy;
        document.body.appendChild(textarea);

        textarea.select();
        textarea.setSelectionRange(0, 99999);

        document.execCommand('copy');

        document.body.removeChild(textarea);

        setCopied(true);

        toast('Link copied!', {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            className: 'text-danger toast-style-1'
        });

        setTimeout(() => {
            setCopied(false);
        }, 2000);
    };

    const raisedispute = async () => {
        try {
            let reqData = {
                booking_id: booking_id,
                reason: dispute
            };

            const res = await NodeaxiosInstance.post('/service/raise-dispute', reqData);

            if (res.status == 200) {
                loadBookingDetails()
                closeDisputeModal();

            }

        } catch (error) {

            const errorMessage = error.response.data?.message || "An error occurred.";
            toast(errorMessage, {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                className: 'text-danger toast-style-1'
            });

        }
    };


    const openDisputeModal = () => {
        canceldisputeModalRef.current.classList.add('show');
        canceldisputeModalRef.current.style.display = 'block';
        setIsModalOpen(true)
    }

    const closeDisputeModal = () => {
        if (canceldisputeModalRef.current) {
            canceldisputeModalRef.current.classList.remove('show');
            canceldisputeModalRef.current.style.display = 'none';
            setIsModalOpen(false)
        }
    }

    const accept_And_EditServices = async () => {
        try {
            const reqData = {
                booking_id: booking_id,
            };

            const response = await NodeaxiosInstance.post('service/accept-edit-booking', reqData);
            if (response.status == 200) {
                const data = response?.data;
                let serviceDetail = {
                    serviceType: record?.book_service_type,
                    vendorId: record?.vendor_id,
                    cart_app_id: record?.book_id,
                    booking_type: "edit_booking",
                    book_id: record?.book_id,
                }

                localStorage.setItem('serviceDetail', JSON.stringify(serviceDetail));
                navigate(`/door-step-service/${record?.vendor_id}`)
            }
        } catch (error) {

            const errorMessage = error.response.data?.message || "An error occurred.";
            toast(errorMessage, {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                className: 'text-danger toast-style-1'
            });

        }
    }

    const cancel_EditServices_Request = async () => {
        try {
            setIsLoading(true)
            closecancelOrderModal()
            const reqData = {
                booking_id: booking_id,
            };

            const response = await NodeaxiosInstance.post('service/cancel-edit-service-request', reqData);
            if (response.status == 200) {
                const data = response?.data;
                setIsLoading(false)
                navigate('/')
            }
        } catch (error) {

            if (error.response) {
                if (error.response.status == 400) {
                    toast.error("Bad request. Please check your input.");
                } else if (error.response.status == 500) {
                    toast.error("Server error. Please try again later.");
                } else {
                    toast.error(`Error: ${error.response.statusText}`);
                }
            } else if (error.request) {

                toast.error("No response from server. Check your internet connection.");
            } else {

                toast.error("Something went wrong.");
            }

        }
    }


    // useEffect(() => {
    //     const savedOptions = JSON.parse(localStorage.getItem("deliveryInstructions")) || [];

    //     setInstructionsOption(savedOptions);
    // }, []);

    // true only when chips, note text or voice note differ from what is saved
    const hasInstructionChanges = () => {
        const sortedJson = (list) => JSON.stringify([...(Array.isArray(list) ? list : [])].sort());
        const chipsChanged = sortedJson(instructionsOption) !== sortedJson(savedInstructionsRef.current);
        const noteChanged = (consulation || '').trim() !== (savedNoteRef.current || '').trim();
        const voiceChanged = recordedAudio instanceof Blob || (!restartRecord) !== !!savedVoiceRef.current;
        return chipsChanged || noteChanged || voiceChanged;
    };

    const handleOptionToggle = (label) => {
        setInstructionsOption((prevOptions = []) => {
            const updatedOptions = prevOptions.includes(label)
                ? prevOptions.filter((option) => option !== label)
                : [...prevOptions, label];

            localStorage.setItem("deliveryInstructions", JSON.stringify(updatedOptions));
            setIsChanged(true);
            return updatedOptions;
        });
    };





    const recorderControls = useAudioRecorder(
        {
            noiseSuppression: true,
            echoCancellation: true,
        },
        (err) => console.error(err)
    );


    // const addAudioElement = (blob) => {
    //     if (!blob || (recordedAudio && recordedAudio.size === blob.size)) {
    //         return;
    //     }

    //     if (oldrecordedAudioblob !== blob) {
    //         if (audioRef.current) {
    //             audioRef.current.pause();
    //             audioRef.current.src = "";
    //             audioRef.current.onended = null;
    //             audioRef.current = null;
    //         }

    //         setOldRecordedAudioblob(blob);
    //         if (recordedAudioUrl) {
    //             URL.revokeObjectURL(recordedAudioUrl);
    //         }

    //         const reader = new FileReader();
    //         reader.readAsDataURL(blob);
    //         reader.onloadend = () => {
    //             const base64data = reader.result;
    //             const newAudioUrl = URL.createObjectURL(blob);
    //             localStorage.setItem("recordedAudio", base64data);

    //             const newAudio = new Audio(base64data);
    //             audioRef.current = newAudio;
    //             audioRef.current.onended = () => {
    //                 setIsPlaying(false);
    //             };

    //             setAudioFile(blob);
    //             setRecordedAudio(blob);
    //             setRecordedAudioUrl(base64data);
    //             setPauseicon(false);
    //             setRestartRecord(false);
    //             setIsPlaying(false);

    //             newAudio.onloadedmetadata = () => {
    //                 localStorage.setItem("recordedAudioUrl", newAudioUrl);
    //                 localStorage.setItem("audioDuration", recordingTime);
    //             };

    //         };
    //     }
    // };

    const addAudioElement = (blob) => {
        if (!blob || (recordedAudio && recordedAudio.size == blob.size)) {

            return;
        }
        if (oldrecordedAudioblob !== blob) {
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.src = "";
                audioRef.current.onended = null;
                audioRef.current = null;
            }

            setOldRecordedAudioblob(blob)
            if (recordedAudioUrl) {
                URL.revokeObjectURL(recordedAudioUrl);
            }

            const newAudioUrl = URL.createObjectURL(blob);
            const newAudio = new Audio(newAudioUrl);

            audioRef.current = newAudio;
            audioRef.current.onended = () => {
                setIsPlaying(false);
            };
            setRecordedAudio(blob);
            setRecordedAudioUrl(newAudioUrl);
            setPauseicon(false);
            setRestartRecord(false);
            setIsPlaying(false);

            newAudio.onloadedmetadata = () => {
                // setAudioDuration(newAudio.duration);
                setAudioDuration(Math.ceil(newAudio.duration));
            };


            const reader = new FileReader();
            reader.onloadend = () => {
                const base64data = reader.result;
                const newAudioUrl = URL.createObjectURL(blob);

                localStorage.setItem("recordedAudio", base64data);
            };
            reader.readAsDataURL(blob);
        }
    };

    useEffect(() => {
        const savedAudio = localStorage.getItem("recordedAudio");
        const storedDuration = localStorage.getItem("audioDuration");

        if (savedAudio) {
            const newAudio = new Audio(savedAudio);
            audioRef.current = newAudio;
            newAudio.onended = () => setIsPlaying(false);
            setRecordingTime(storedDuration);
            setRecordedAudioUrl(savedAudio);
            setRestartRecord(false);
            setPauseicon(false);
            setIsPlaying(false);

            newAudio.onloadedmetadata = () => {
                setAudioDuration(newAudio.duration.toFixed(2));
            };
        }
    }, []);


    const togglePlayAudio = () => {
        if (!audioRef.current) return;

        if (isPlaying) {
            audioRef.current.pause();
        } else {
            audioRef.current.play().catch(e => console.error("Playback failed:", e));
        }

        setIsPlaying(!isPlaying);
    };


    useEffect(() => {
        let interval;
        if (isPlaying && audioRef.current) {
            interval = setInterval(() => {
                setPlayTime(audioRef.current.currentTime);
            }, 500);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isPlaying]);

    useEffect(() => {
        if (pauseicon) {
            timerRef.current = setInterval(() => {
                setRecordingTime((prev) => prev + 1);
            }, 1000);
        } else {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }

        return () => clearInterval(timerRef.current);
    }, [pauseicon]);

    const deleteRecordedAudio = useCallback(() => {

        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.src = "";
            audioRef.current.onended = null;
            audioRef.current = null;
        }


        if (recordedAudioUrl) {
            URL.revokeObjectURL(recordedAudioUrl);
        }

        setRecordedAudio(null);
        setRecordedAudioUrl(null);
        setAudioDuration(null);
        setIsPlaying(false);
        setPauseicon(false);

        setRestartRecord(true);
        setTimeout(() => setRestartRecord(true), 0);
        setRecordingTime(0);
        // forget the saved voice URL so a later Save does not write it back
        setOldRecordurl(null);
        sendInstructionsRef.current?.(0);
        localStorage.removeItem("recordedAudio");
        localStorage.removeItem("audioDuration");

    }, [recordedAudioUrl]);


    const ffmpeg = new FFmpeg();

    const convertToMp4 = async (audioBlob) => {
        if (!ffmpeg.loaded) await ffmpeg.load();

        const buffer = await audioBlob.arrayBuffer();
        const uint8Array = new Uint8Array(buffer);

        const inputFile = "input.webm"; // or "input.wav" based on your blob
        const outputFile = "output.mp4";

        await ffmpeg.writeFile(inputFile, uint8Array);
        await ffmpeg.exec(["-i", inputFile, outputFile]);

        const outputData = await ffmpeg.readFile(outputFile);

        return new Blob([outputData], { type: "video/mp4" });
    };

    const handleSendInstructions = async (type) => {
        try {
            let url = "";


            if ((type == 1 || type == 2) && recordedAudio && recordedAudio instanceof Blob) {

                const mp4Blob = await convertToMp4(recordedAudio);

                const formData = new FormData();
                formData.append("file", mp4Blob, "audio.mp4");

                const uploadRes = await NodeaxiosInstance.post(
                    "/product/upload-audio-note",
                    formData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );

                if (uploadRes.status == 200 && uploadRes.data?.file_url) {
                    url = uploadRes.data.file_url;
                    localStorage.setItem("recoredURL", url);
                } else {
                    console.error("Failed to upload audio note");
                    return;
                }
            }

            const voiceNote =
                type == 0 ? "" :
                    (type == 1 || type == 2) && recordedAudio instanceof Blob ? url :
                        type == 1 ? oldRecordurl :
                            type == 2 ? oldRecordurl : "";

            const reqData = {
                booking_id,
                delivery_instructions: instructionsOption,
                additional_notes: consulation,
                voice_note: voiceNote,
            };



            const updateRes = await NodeaxiosInstance.post("service/update-service-instructions", reqData);

            if (updateRes.status === 200) {
                setIsChanged(false);
                if (type !== 0) {
                    closeinstructionsModal();
                    setInstructionIsLoading(false);
                }
                loadBookingDetails();
            } else {
                console.error("Failed to update instructions");
                toast.error("Unable to save instructions. Please try again.");
            }
        } catch (error) {
            console.error("Error sending instructions:", error);
            setInstructionIsLoading(false);
            toast.error(error?.response?.data?.message || "Unable to save instructions. Please try again.");
        }
    };



    sendInstructionsRef.current = handleSendInstructions;

    const handleSave = async () => {
        localStorage.setItem("additionalNotes", consulation);

        const additionalNotes = localStorage.getItem("additionalNotes");


        if (!recordedAudio) {
            closeinstructionsModal();
            return;
        }

        try {
            const mp4Blob = await convertToMp4(recordedAudio);

            const formData = new FormData();
            formData.append("file", mp4Blob, "audio.mp4");

            const response = await NodeaxiosInstance.post(
                "/product/upload-audio-note",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response.status === 200) {
                localStorage.setItem("recoredURL", response.data.file_url);
                closeinstructionsModal();
            }
        } catch (error) {
            console.error("Upload failed:", error);
        }
    };


    const formatTime = (seconds) => {
        const rounded = Math.ceil(seconds);
        const m = Math.floor(rounded / 60).toString().padStart(2, "0");
        const s = (rounded % 60).toString().padStart(2, "0");
        return `${m}:${s}`;
    };

    const bd = record?.booking_details;
    const isOfferPrice = bd?.applied_card_detail?.offer_type == "4";
    const toBillService = (list) => (list || []).map(x => ({ product_name: x.service_name, price: x.service_price, unit_quantity: 1 }));
    const serviceBillingData = {
        vendor_company_name: record?.book_staff?.vendor_name || record?.vendor_name,
        vendor_address: record?.vendor_address,
        vendor_mbl: record?.vendor_mbl,
        order_id: record?.book_id,
        order_date: bd?.create_at || record?.book_date_time,
        order_item: bd?.book_service_details?.map(item => ({
            item_name: item.service_name, item_quantity: 1, item_price: item.service_price,
        })),
        Saved_by: bd?.discount_detail?.lable,
        discount_amount: bd?.discount_status == 1 ? bd?.discount_detail?.discount_amount : 0,
        sub_total: isOfferPrice ? bd?.applied_card_detail?.offer_price : bd?.net_amount,
        user_platform_charges: record?.payment_method != "loyalty" ? bd?.user_platform_charges : 0,
        round_off: bd?.round_off,
        gst_percentage: record?.payment_method != "loyalty" && bd?.GST_status == 1 ? (parseFloat(bd?.SGST_percentage) || 0) * 2 : 0,
        total_amount: isOfferPrice
            ? (Number(bd?.applied_card_detail?.offer_price || 0) + Number(bd?.user_platform_charges || 0)
                + (bd?.GST_status == 1 ? Number(bd?.SGST_amount || 0) + Number(bd?.CGST_amount || 0) : 0)
                + Number(bd?.round_off || 0)).toFixed(2)
            : bd?.payment_details?.total_amount,
        applied_card_detail: bd?.applied_card_detail,
        offer_details: {
            buy_products: toBillService(bd?.offer_services?.buy_services),
            get_products: toBillService(bd?.offer_services?.get_services),
            buy_products_total: bd?.offer_services?.buy_services_total,
            get_products_total: bd?.offer_services?.get_services_total,
        },
    };

    return (
        <>
            {
                pageLoaded ?
                    <>
                        <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
                            <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                                <img src={p_nav_previous} width={'24px'} height={'16px'} alt='Previous Button' role='button' onClick={() => fromPage == "ReviewPay" ? navigate('/') : navigate(-1)} />
                                <div className='ff-balooPaaji2-bold fs-20 ms-2 ps-1'>Service Pass</div>
                            </div>
                        </div>
                        {/* <button onClick={() => openPaymentSuccessModal()}>open</button> */}
                        <div className="scroller-style-y">
                            <div className="container-fluid ps-4 pe-4 mt-3">
                                <div className="row">
                                    <div className="col bg-white">
                                        <div className="ticketAndSchedule ms-2 me-2 mt-4 mb-4">
                                            {
                                                record?.booking_details?.book_status !== '4' ?
                                                    record.book_service_type == "2" &&
                                                    <nav>
                                                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                                            <button className="nav-link active ff-poppins-semiBold w-50 fs-16 py-2 rounded-0" id="nav-ticket-tab" data-bs-toggle="tab" data-bs-target="#nav-ticket" type="button" role="tab" aria-controls="nav-ticket" aria-selected="true">Ticket</button>
                                                            <button className="nav-link w-50 ff-poppins-semiBold fs-16 py-2 rounded-0" id="nav-schedule-tab" data-bs-toggle="tab" data-bs-target="#nav-schedule" type="button" role="tab" aria-controls="nav-schedule" aria-selected="false">Schedule</button>
                                                        </div>
                                                    </nav>
                                                    : <></>
                                            }

                                            <div className="tab-content" id="nav-tabContent">
                                                <div className="tab-pane fade show active" id="nav-ticket" role="tabpanel" aria-labelledby="nav-ticket-tab">
                                                    {(record.booking_details?.book_que_status == "0" && !(["3", "4"].includes(String(record.booking_details?.book_status)))) &&
                                                        <div className="text-center">
                                                            <img src={record.booking_details?.book_qrcode} width={'60%'} height={'60%'} />
                                                        </div>
                                                    }

                                                    {(record.booking_details?.book_que_status == "1") &&
                                                        // Stopwatch start
                                                        <div className="d-flex justify-content-center mt-2 mb-3">
                                                            <div className="d-flex justify-content-center align-items-center servicePassTimer rounded-circle">
                                                                <div className="text-center">
                                                                    <div className="ff-poppins-regular fs-12">Service Started at {record.booking_details?.book_start_time}</div>
                                                                    <Stopwatch timerStart={startTimer} startTime={record?.booking_details?.book_start_date_time} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        // Stopwatch Ends
                                                    }

                                                    {record.booking_details?.book_que_status == "2" &&
                                                        // Ratings Start
                                                        <div className="mb-4">
                                                            <div className="text-center  lh-lg">
                                                                <div className="fs-16 fw-600 ff-poppins-bold">Duration {record.booking_details?.time_diff_view}</div>
                                                                <div className="fs-13 m-0 p-0 ff-poppins-regular">Service Started at {record.booking_details?.book_start_time}</div>
                                                                <div className="fs-13 m-0 p-0 ff-poppins-regular">Completed at {record.booking_details?.book_end_time}</div>
                                                            </div>

                                                            {/* <div className="secondary-bg-3 text-center p-3 ms-2 me-2 rounded-1">
                                                    <div className="fs-12 fw-600 ff-medium fw-bold">Service Completed, Rate Service</div>
                                                    <div className="d-flex justify-content-center mt-3 mb-3">
                                                        {ratings.map((filled, index) => (
                                                        <div key={index} onClick={() => handleStarClick(index)}>
                                                            {filled ? (
                                                            <IoMdStar color="gold" size={30} />
                                                            ) : (
                                                            <IoIosStarOutline color="gold" size={30} />
                                                            )}
                                                        </div>
                                                        ))}
                                                        </div>
                                                    <div className="input-group">
                                                        <input type="text" className="form-control border-0 fs-12 fw-600" placeholder="Enter Feedback" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                                                        <span className="input-group-text border-0 bg-white fs-12 fw-600 primary-text" id="basic-addon2">POST</span>
                                                    </div>
                                                </div> */}
                                                            {
                                                                editRateing ?

                                                                    <div className="ratingContainer">
                                                                        <div className="ff-poppins-medium fs-14 text-center">
                                                                            The  Service has been completed. Please <br></br>rate the service
                                                                        </div>

                                                                        <div className="feedback mt-1 mb-2">
                                                                            {ratings.map((filled, index) => (
                                                                                <div key={index} onClick={() => handleStarClick(index)}>
                                                                                    {filled ? (
                                                                                        <IoMdStar color="gold" size={30} />
                                                                                    ) : (
                                                                                        <IoIosStarOutline color="gold" size={30} />
                                                                                    )}
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                        <fieldset className="feedbackInput rounded-3 secondary-border" >
                                                                            <input placeholder="Enter your review" className="feedbackEnter custom-input bg-white fs-12 text-darl ff-poppins-medium" value={feedback} maxLength={250} onChange={(e) => setFeedback(e.target.value)} type="text" />
                                                                            <button className="form-submit col-2 ff-poppins-medium ouline-none primary-bg fs-10 rounded-1 text-light border-0 p-1" onClick={() => starRating()}  >
                                                                                POST
                                                                            </button>
                                                                        </fieldset>
                                                                    </div>
                                                                    :
                                                                    <div className="rounded-3 secondary-border mt-2">
                                                                        <div className="p-3">
                                                                            <h6 className="fs-14 ff-poppins-medium p-0 m-0 primary-text">Delivery Rating and Review</h6>
                                                                            <div className="d-flex justify-content-between mt-1">
                                                                                <div className="delivery_star d-flex">
                                                                                    {ratings.map((filled, index) => (
                                                                                        <div key={index} className="fs-14" >
                                                                                            {filled ? <IoMdStar color="gold" size={25} /> : <IoIosStarOutline color="gold" size={25} />}
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                                <div className="rounded-2 align-self-center text-dark secondary-border text-center fs-12 ff-poppins-semiBold col-2" onClick={() => setEditRateing(true)} >
                                                                                    Edit
                                                                                </div>
                                                                            </div>
                                                                            {
                                                                                feedback ?
                                                                                    <h6 className="fs-12 mt-1 ff-poppins-medium p-0 m-0 primary-text mt-2">{feedback} </h6> :
                                                                                    <h6 className="fs-12 mt-1 ff-poppins-medium p-0 m-0 primary-text mt-2">Please give your feedback</h6>
                                                                            }
                                                                        </div>
                                                                    </div>


                                                            }


                                                            {/*

                                                             <div className="feedback_box p-3" >
                                                                                                  <div className=" text-center">
                                                                                                    <h6 className="p-0 m-0 ff-poppins-medium primary-text" >Rate the delivery partner</h6>
                                                                                                    <p className="p-0 m-0 ff-poppins-medium fs-10" >Rate the delivery experience!</p>
                                                                                                  </div>
                                                                                                  <div className="feedback mt-1 mb-1">
                                                                                                    {pilotratings.map((filled, index) => (
                                                                                                      <div key={index} onClick={() => handlePiltoStarClick(index)}>
                                                                                                        {filled ? <IoMdStar color="gold" size={30} /> : <IoIosStarOutline color="gold" size={30} />}
                                                                                                      </div>
                                                                                                    ))}
                                                                                                  </div>
                                                                                                  <fieldset className="feedbackInput rounded-3 secondary-border" >
                                                                                                    <input placeholder="Enter your review" className="feedbackEnter custom-input bg-white fs-12 text-darl ff-poppins-medium" value={delivery_partner_feedback} maxLength={250} onChange={(e) => setDelivery_partner_feedback(e.target.value)} type="text" />
                                                                                                    <button className="form-submit col-2 ff-poppins-medium ouline-none primary-bg fs-10 rounded-1 text-light border-0 p-1" onClick={() => delivery_Partner_rateing()}  >
                                                                                                      POST
                                                                                                    </button>
                                                                                                  </fieldset>
                                                                                                </div>
                                                                                                :
                                                                                                <div className="rounded-3 secondary-border mt-2">
                                                                                                  <div className="p-3">
                                                                                                    <h6 className="fs-14 ff-poppins-medium p-0 m-0 primary-text">Delivery Rating and Review</h6>
                                                                                                    <div className="d-flex justify-content-between mt-1">
                                                                                                      <div className="delivery_star d-flex">
                                                                                                        {pilotratings.map((filled, index) => (
                                                                                                          <div key={index} className="fs-14" >
                                                                                                            {filled ? <IoMdStar color="gold" size={25} /> : <IoIosStarOutline color="gold" size={25} />}
                                                                                                          </div>
                                                                                                        ))}
                                                                                                      </div>
                                                                                                      <div className="rounded-2 align-self-center text-dark secondary-border text-center fs-12 ff-poppins-semiBold col-2" onClick={() => setEditDeliveryRateing(true)} >
                                                                                                        Edit
                                                                                                      </div>
                                                                                                    </div>
                                                                                                    {
                                                                                                      feedback ?
                                                                                                        <h6 className="fs-12 mt-1 ff-poppins-medium p-0 m-0 primary-text mt-2">{delivery_partner_feedback} </h6> :
                                                                                                        <h6 className="fs-12 mt-1 ff-poppins-medium p-0 m-0 primary-text mt-2">Please give your feedback</h6>
                                                                                                    }
                                                                                                  </div>
                                                                                                </div>
                                                            */}
                                                        </div>



                                                        // Ratings Ends
                                                    }
                                                </div>

                                                <div className="tab-pane fade" id="nav-schedule" role="tabpanel" aria-labelledby="nav-schedule-tab">
                                                    <div className="timeline p-4">
                                                        {/* <ul>
                                                {record.doorstep_que_detail?.map(item => {
                                                    return (
                                                        <li className={`${item.date != '' ? "active" : ""}`}>

                                                            <div className={`fs-10 fw-500 ${item.date != '' ? "ff-bold" : "secondary-text-2"}`}>{item.lable}</div>
                                                            {item.date != '' &&
                                                                <div className="fs-10 fw-500">{item.date}</div>
                                                            }
                                                        </li>
                                                    )
                                                })}
                                            </ul> */}

                                                        <div className="service-stepper">
                                                            {/* Check if deliverystep is not undefined before rendering VerticalStepper */}
                                                            {deliverystep && deliverystep.length > 0 && (
                                                                <VerticalStepper steps={deliverystep} />
                                                            )}
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div className="container-fluid">
                                            <div className="row">
                                                <div className='d-flex justify-content-between col-12'>
                                                    <div className={``}>
                                                        <div className="ff-poppins-bold fs-14">{record.book_date_time}</div>
                                                        <div className="ff-poppins-semiBold fs-14">Booking ID - {record.book_id}</div>
                                                    </div>
                                                    {
                                                        record?.booking_details?.book_status == '3' ?
                                                            <div className="">
                                                                <button className=" unpaidbtn px-2 py-1 align-self-center fs-11 ff-poppins-semiBold me-1">Canceled</button>
                                                            </div>
                                                            :
                                                            record?.booking_details?.book_status == '4' ?
                                                                <div className=" ">
                                                                    <button className=" unpaidbtn px-2 py-1 align-self-center fs-11 ff-poppins-semiBold me-1">Missed</button>
                                                                </div>
                                                                :
                                                                record.booking_details?.book_status != 4 && record.booking_details?.book_status != 2 &&
                                                                <div className={`text-center otp-sec ff-bold px-1 py-0`}>
                                                                    <div className="ff-poppins-bold fs-14">OTP</div>
                                                                    <div className="ff-poppins-bold fs-14">{record.booking_details?.book_code}</div>
                                                                </div>

                                                    }
                                                </div>

                                                {
                                                    record.book_service_type == "2" &&
                                                    <div className="col-12 mt-4">

                                                        <div className="fs-15 fw-600 ff-poppins-semiBold mb-2">Service Address</div>

                                                        <div className="container-fluid deleiveryAddress rounded-3 pt-1 pb-1">
                                                            <div className="row align-items-center">
                                                                <div className="col-2">
                                                                    {record.service_location.location_type_id == '1' ? (
                                                                        <IoMdHome className="homeIconPP" />
                                                                    ) : record.service_location.location_type_id == '2' ? (
                                                                        <MdWork className="homeIconPP" />
                                                                    ) : record.service_location.location_type_id == '3' ? (
                                                                        <IoLocationSharp className="homeIconPP" />
                                                                    ) :
                                                                        <></>
                                                                    }
                                                                </div>
                                                                <div className="col-8 ff-poppins-regular">
                                                                    <div className="fs-14 fw-500 ff-medium fw-bold">{record.service_location.location_type}</div>

                                                                    <div className="fs-12 fw-400 clamped-text" id="Address">{record.service_location.address}</div>
                                                                    <div className="fs-11 fw-400">
                                                                        <p className="p-0 m-0"> {
                                                                            record.service_location ?
                                                                                record.service_location.distance.text + ' - ' + record.service_location.duration.text
                                                                                : ''
                                                                        }</p>
                                                                    </div>
                                                                </div>
                                                                <div className="col-2">
                                                                    <GoChevronRight />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                                <div className="col-12 ps-1 pe-1 mt-4">
                                                    <div className="ff-poppins-semiBold fs-16 mb-2 ms-2">Booking For</div>
                                                    <div className="profile-card-1 d-flex">
                                                        <img src={record.book_for?.image} className="rounded-3" width={'70px'} height={'70px'} />
                                                        <div className="ms-3 w-100">
                                                            <div className="ff-poppins-semiBold fs-14">
                                                                {record.book_for?.name}
                                                            </div>
                                                            <div className="ff-poppins-regular fs-10 mb-1">
                                                                {record.book_for?.category_name}
                                                            </div>
                                                            {
                                                                record.vendor_type_id == '2' ?
                                                                    <div className='ff-poppins-regular fs-10 mb-1'>
                                                                        {record.book_for?.type} - {record.book_for?.breed}
                                                                    </div> : <></>
                                                            }
                                                            <div className="ff-poppins-regular fs-14 text-secondary">{record.book_for?.relationship}</div>
                                                            {showMoreInforUser
                                                                ?
                                                                <div>
                                                                    {
                                                                        record.vendor_type_id == '1' ?
                                                                            <div className='ff-poppins-regular fs-14 mb-1'>
                                                                                {record.book_for?.gender}  </div> :
                                                                            record.vendor_type_id == '2' ?
                                                                                <div className='ff-poppins-regular fs-14 mb-1'>
                                                                                    {record.book_for?.type} - {record.book_for?.age} Years - {record.book_for?.weight} Kg
                                                                                </div> : <></>
                                                                    }
                                                                    <div className='ff-poppins-regular fs-14 mb-1'>{record.book_for?.register_number}</div>
                                                                    <hr className='mt-1 mb-1 text-secondary' />
                                                                    {
                                                                        record.vendor_type_id == '2' ?
                                                                            <div className='ff-poppins-regular text-center col-4 rounded-1 ff-poppins-regular temperamentBox fs-10 '>
                                                                                {record.book_for?.temperament.toUpperCase()}
                                                                            </div> : <></>
                                                                    }

                                                                    <div className='ff-poppins-regular fs-12 '>
                                                                        {record.book_for?.about}
                                                                    </div>
                                                                    <div className='ff-poppins-semiBold fs-13 d-flex align-items-center primary-text' role='button' onClick={() => { setShowMoreInforUser(!showMoreInforUser) }}>
                                                                        Less info
                                                                        <img
                                                                            src={p_up_arrow_circle}
                                                                            width={'15px'}
                                                                            height={'15px'}
                                                                            alt='Show Less Info'
                                                                            role='button'
                                                                            className='ms-1'
                                                                        />
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className='ff-poppins-semiBold fs-13 d-flex align-items-center primary-text' role='button' onClick={() => { setShowMoreInforUser(!showMoreInforUser) }}>
                                                                    More info
                                                                    <img src={p_down_arrow_circle} className="ms-1" width={'15px'} height={'15px'} />
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                                {
                                                    record?.staff_app_status == 1 && record.book_staff?.staff_id != "1" ?
                                                        <div className="col-12 ps-1 pe-1 mt-4">
                                                            <div className="ff-poppins-semiBold fs-16 mb-2 ms-2">Appointments with</div>
                                                            <div className="profile-card-1 d-flex">
                                                                <img src={record.book_staff?.staff_image} onError={(event) => { event.target.onerror = null; event.target.src = 'https://pingle.s3.ap-south-1.amazonaws.com/uploads/vendor/profile/user.jpg'; }} className="rounded-3" width={'70px'} height={'70px'} />
                                                                <div className="ms-3 w-100">
                                                                    <div className="ff-poppins-semiBold fs-14">{record.book_staff?.staff_name}</div>
                                                                    <div className="ff-poppins-regular fs-12 text-secondary">{record.book_staff?.staff_designation}</div>
                                                                    {
                                                                        showMoreInforStaff
                                                                            ?
                                                                            <div>
                                                                                <div className='ff-poppins-regular fs-12 mb-1'>
                                                                                    {record.book_staff?.staff_specialist}
                                                                                </div>
                                                                                <hr className='mt-1 mb-1 text-secondary' />
                                                                                <div className='ff-poppins-regular fs-12 '>
                                                                                    {record.book_staff?.staff_about}
                                                                                </div>
                                                                                <div className='ff-poppins-semiBold fs-13 d-flex align-items-center primary-text' role='button' onClick={() => { setShowMoreInforStaff(!showMoreInforStaff) }}>
                                                                                    Less info
                                                                                    <img src={p_up_arrow_circle} width={'15px'} height={'15px'} alt='Show Less Info' role='button' className='ms-1' />
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            <div className='ff-poppins-semiBold fs-13 d-flex align-items-center primary-text' role='button' onClick={() => { setShowMoreInforStaff(!showMoreInforStaff) }}>
                                                                                More info
                                                                                <img src={p_down_arrow_circle} className="ms-1" width={'15px'} height={'15px'} />
                                                                            </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>

                                                        : <></>
                                                }

                                                {
                                                    // shown for active doorstep bookings even before any instructions exist (so they can be added and sent);
                                                    // finished/cancelled bookings only show it if instructions were already saved
                                                    record.book_service_type == "2" && (record.note_status == 1 || (bookingstatus != 2 && bookingstatus != 3)) &&
                                                    <div className="  mt-1">
                                                        <h6 className="fs-14 ff-poppins-semiBold mt-3">Service Instructions</h6>
                                                        <div className="store-card-1 mt-3">
                                                            <div className=" cursorDefault mt-1">
                                                                <div className="fs-10 ff-poppins-regular text-center">Add service instructions for your service visit !</div>
                                                                <div className=" d-flex  scroller-style-x ">
                                                                    <div className="d-flex mt-1 overflow-auto scroller-style-x">
                                                                        {(() => {
                                                                            const allOptions = [
                                                                                { id: 1, icon: bell_icon, label: "Don't ring the bell" },
                                                                                { id: 2, icon: door_icon, label: "Handle with care" },
                                                                                { id: 3, icon: Avoid_call, label: "Avoid calling" },
                                                                                { id: 4, icon: pet_foot, label: "Pet at home" },
                                                                            ];

                                                                            const filteredOptions =
                                                                                instructionsOption?.delivery_instructions?.length > 0
                                                                                    ? allOptions?.filter((option) =>
                                                                                        instructionsOption?.delivery_instructions?.includes(option?.label)
                                                                                    )
                                                                                    : allOptions;

                                                                            return (
                                                                                <div className="d-flex mt-3 overflow-auto scroller-style-x">
                                                                                    {filteredOptions.map((option) => {
                                                                                        const isSelected = instructionsOption.includes(option.label);

                                                                                        return (
                                                                                            <div key={option.id} className={`${isSelected ? "select-primary-box" : ""} Instructions-box mx-1`}
                                                                                                onClick={() => handleOptionToggle(option.label)}  >
                                                                                                {typeof option.icon === "string" ? (
                                                                                                    <img src={option.icon} alt={option.label} className="instrctionIcons" />
                                                                                                ) : (
                                                                                                    <div className="icon-wrapper">{option.icon}</div>
                                                                                                )}
                                                                                                <p className="fs-10 ff-poppins-semiBold p-0">{option.label}</p>
                                                                                            </div>
                                                                                        );
                                                                                    })}
                                                                                </div>
                                                                            );
                                                                        })()}

                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div className="d-flex justify-content-between mt-2 ">
                                                                {recordedAudio || consulation ?
                                                                    <div className="addedInstructionContainer d-flex justify-content-between align-center w-100 p-2" onClick={() => openinstructionsModal()} >
                                                                        <div className="addedInstrcRight ff-poppins-semiBold d-flex align-center gap-1">
                                                                            <span className="fs-12 primary-text"> <MdEditDocument /></span>
                                                                            Edit instructions
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    <div>
                                                                        <p className="p-0 m-0 fs-12 ms-2 ff-poppins-semiBold primary-text" onClick={() => openinstructionsModal()}>+  Add an instructions note</p>
                                                                    </div>
                                                                }

                                                                {hasInstructionChanges() && (
                                                                    <div className="InstructionsSendBtn" onClick={() => handleSendInstructions(2)}  >
                                                                        <div className="d-flex align-items-center gap-1">
                                                                            <span>Send</span>
                                                                            <IoSend size={12} />
                                                                        </div>
                                                                    </div>

                                                                )}
                                                            </div>
                                                        </div>

                                                    </div>
                                                }


                                                <div className="col-12 ps-1 pe-1 mt-4">
                                                    <div className="store-card-1 d-flex">

                                                        <div onClick={() => navigate(`/vendor/${record.vendor_id}`)} className="d-flex justify-content-between col-9">
                                                            <img className="rounded-3" src={record.vendor_logo} width={'70px'} height={'70px'} />
                                                            <div className="ms-2">
                                                                <div className="ff-poppins-semiBold fs-14">{record.book_staff?.vendor_name}</div>
                                                                <div className="ff-poppins-semiBold fs-10 text-secondary">&#x2022; MID {record.book_staff?.vendor_id} &#x2022; {record.vendor_type_name} </div>
                                                                <div className="ff-poppins-semiBold fs-10 singleline-text text-secondary">&#x2022; {record.vendor_address} </div>
                                                            </div>
                                                        </div>

                                                        <div className="ms-auto d-flex justify-content-center align-items-center history-btn col-3">
                                                            <Link to={`/history/${vendor_id}`} className="text-decoration-none">
                                                                <div className="text-center history">
                                                                    <img src={p_history_icon} width={'36px'} height={'36px'} alt="History Icon" />
                                                                    <div className="ff-poppins-semiBold fs-13 primary-text">History</div>
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="container-fluid mt-4 primary-bg rounded-3 p-3">
                                                    <div className="row">

                                                        <div className="col-4 fs-12 fw-600 text-white   d-flex align-items-center justify-content-center">
                                                            <a href={`tel:${record.vendor_mbl}`} className='text-decoration-none d-flex'>
                                                                <img src={p_call} width={'20px'} height={'20px'} />
                                                                <div className="ff-poppins-semiBold text-white fs-15 ms-2">Call</div>
                                                            </a>
                                                        </div>
                                                        <div className="col-4 fs-12 fw-600 text-white   d-flex align-items-center justify-content-center text-sec" onClick={() => navigate(`/chat/booking/${record.book_id}`)}>
                                                            <img src={p_text_message} width={'20px'} height={'20px'} />
                                                            <div className="ff-poppins-semiBold fs-15 ms-2">Text</div>
                                                        </div>
                                                        <div className="col-4 fs-12 fw-600 text-white   d-flex align-items-center justify-content-center" role="button" onClick={() => copyToClipboard()}>
                                                            <img src={p_share} width={'20px'} height={'20px'} />
                                                            <div className="ff-poppins-semiBold fs-15 ms-2">Share</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 mt-4 d-flex justify-content-between align-items-center">
                                                    <span className="ff-poppins-semiBold fs-15 primary-text">Billing Information</span>
                                                    <span><DownLossdbillingPDF data={serviceBillingData} /></span>
                                                </div>
                                                {record?.booking_by_type == 'vendor' ?
                                                    <div className="fs-12 ff-poppins-regular mt-1 mb-2">
                                                        Appointment initiated at {record.book_initiate_time} by {record.booking_by} ({record.vendor_name}) for {record.book_for.name}
                                                    </div>
                                                    :
                                                    <div className="fs-12 ff-poppins-regular mt-1 mb-2">
                                                        Booking initiated at {record.book_initiate_time} by {record.user_name} for {record.book_for.name}
                                                    </div>
                                                }
                                                <hr></hr>
                                                <div className="col-12 ">
                                                    {/* Buy get offer */}
                                                    {
                                                        record?.booking_details?.applied_card_detail?.offer_type == "3" ?
                                                            <div>
                                                                <div>
                                                                    <div className='ff-poppins-semiBold primary-text fs-14 mt-2 pt-1 pb-1'>
                                                                        Buy Service{record?.booking_details?.offer_services?.buy_services.length > 1 ? 's' : ''}
                                                                    </div>
                                                                    {
                                                                        record?.booking_details?.offer_services?.buy_services.map(list => {

                                                                            return (
                                                                                <div className="d-flex justify-content-between ff-poppins-regular fs-12 mb-1">
                                                                                    <span className="m-0 p-0 ">{list.service_name} </span>
                                                                                    <span className="m-0 p-0 ">   {list.service_price}.00</span>
                                                                                </div>
                                                                            )
                                                                        })

                                                                    }
                                                                    <div className='d-flex justify-content-between ff-poppins-medium fs-12 totalBar'>
                                                                        <span className='m-0 mt-1 text-success mb-1'>Total (Offer Price)</span>
                                                                        <span className='m-0 mt-1 text-success mb-1'>Rs.{record?.booking_details?.offer_services?.buy_services_total} </span>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <div className='ff-poppins-semiBold primary-text fs-14 mt-2 pt-1 pb-1'>
                                                                        Get Service{record?.booking_details?.offer_services?.get_services.length > 1 ? 's' : ''}(Free)
                                                                    </div>
                                                                    {
                                                                        record?.booking_details?.offer_services?.get_services.map(list => {
                                                                            return (
                                                                                <div className="d-flex justify-content-between ff-poppins-regular fs-12 mb-1">
                                                                                    <span className="m-0">{list.service_name} </span>
                                                                                    <span className="m-0"> {list.service_price}.00  </span>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }

                                                                    <div className='d-flex justify-content-between ff-poppins-medium fs-12 border-top-Dashed '>
                                                                        <span className='m-0 mt-1 text-success mb-1'>Total (Free Value)</span>
                                                                        <span className='m-0 mt-1 text-success mb-1'>Rs.{record?.booking_details?.offer_services?.get_services_total}</span>
                                                                    </div>
                                                                </div>

                                                            </div> :
                                                            <div>
                                                                <div className="ff-poppins-semiBold fs-15 primary-text mb-1">Services</div>
                                                                {record.booking_details?.book_service_details?.map(item => (
                                                                    <div className="d-flex justify-content-between mb-1 ">
                                                                        <span className="ff-poppins-regular fs-12">{item.service_name}</span>
                                                                        <span className="ff-poppins-regular fs-12">{item.service_price}.00</span>
                                                                    </div>
                                                                ))}
                                                                {
                                                                    record?.booking_details?.discount_status == 1 ?
                                                                        <div className='d-flex justify-content-between  border-top-Dashed ff-poppins-regular fs-12  borderTop'>
                                                                            <span className='m-0 mt-1 text-success mb-1'>{record?.booking_details?.discount_detail?.lable} </span>
                                                                            <span className='m-0 mt-1 text-success mb-1'>{record?.booking_details?.discount_detail?.discount_amount}</span>
                                                                        </div>
                                                                        : <></>
                                                                }
                                                            </div>
                                                    }
                                                    {/* Billing details */}
                                                    <div className="service-section pt-2 pb-2 mb-2 ">

                                                        <div className="d-flex justify-content-between">
                                                            <div className={`fs-12 ff-poppins-regular ${record?.booking_details?.applied_card_detail?.offer_type == "4" && 'text-success'}`}>
                                                                Subtotal {record?.booking_details?.applied_card_detail?.offer_type == "4" ? "(Offer Price)" : ""} </div>

                                                            <div className={`fs-12 ff-poppins-regular ${record?.booking_details?.applied_card_detail?.offer_type == "4" && 'text-success'}`}>
                                                                {record?.booking_details?.applied_card_detail?.offer_type == "4" ?
                                                                    ((Number(record?.booking_details?.applied_card_detail?.offer_price || 0)).toFixed(2)) :

                                                                    record.booking_details?.net_amount}</div>
                                                        </div>

                                                        {record.payment_method != "loyalty" ?
                                                            <div className="d-flex justify-content-between">
                                                                <div className="fs-12 ff-poppins-regular">Platform charges</div>
                                                                <div className="fs-12 ff-poppins-regular">{record.booking_details?.user_platform_charges}</div>
                                                            </div> : ""}

                                                        {
                                                            record.payment_method == "loyalty" ?
                                                                <div className="d-flex justify-content-between">
                                                                    <div className="fs-12 ff-poppins-regular">Pingle points redeemed ({record.redeemed_offer?.offer_points})</div>
                                                                    <div className="fs-12 ff-poppins-regular">-{record.booking_details?.net_amount}</div>
                                                                </div>
                                                                : record?.booking_details?.GST_status == 1 ?
                                                                    <div>
                                                                        <div className="d-flex justify-content-between">
                                                                            <div className="fs-12 ff-poppins-regular">SGST {record.booking_details?.SGST_percentage}</div>
                                                                            <div className="fs-12 ff-poppins-regular">{record.booking_details?.SGST_amount}</div>
                                                                        </div>
                                                                        <div className="d-flex justify-content-between">
                                                                            <div className="fs-12 ff-poppins-regular">CGST {record.booking_details?.CGST_percentage}</div>
                                                                            <div className="fs-12 ff-poppins-regular">{record.booking_details?.CGST_amount}</div>
                                                                        </div>
                                                                    </div> : ""

                                                        }

                                                        {
                                                            record.booking_details?.round_off != 0 ?
                                                                <div className="d-flex justify-content-between">
                                                                    <div className="fs-12 ff-poppins-regular">Round Off</div>
                                                                    <div className="fs-12 ff-poppins-regular">{record.booking_details?.round_off}</div>
                                                                </div>
                                                                : <></>
                                                        }

                                                    </div>

                                                    <div className=" mt-2 mb-4">
                                                        {record?.Billing_status != 1 ?
                                                            <div className="d-flex justify-content-between">
                                                                <div className="ff-poppins-semiBold fs-16">Total </div>
                                                                <div className="ff-poppins-semiBold d-flex align-items-center gap-2 fs-14">
                                                                    {
                                                                        record.payment_method != "loyalty" ?
                                                                            paymenttype != '3' ?
                                                                                record.booking_details?.payment_details?.payment_status == '1' ?
                                                                                    <button className="paidBtnSP align-self-center fs-11 ff-poppins-semiBold me-1"> PAID  </button>
                                                                                    :
                                                                                    <button className="unpaidbtn align-self-center fs-11 ff-poppins-semiBold me-1"> UNPAID </button>
                                                                                : <></>
                                                                            : ""
                                                                    }
                                                                    <div>Rs.{record?.booking_details?.applied_card_detail?.offer_type == "4" ?
                                                                        ((Number(record?.booking_details?.applied_card_detail?.offer_price || 0)
                                                                            + Number(record?.booking_details?.user_platform_charges || 0)
                                                                            + (record?.booking_details?.GST_status == 1
                                                                                ? Number(record?.booking_details?.SGST_amount || 0) + Number(record?.booking_details?.CGST_amount || 0)
                                                                                : 0)
                                                                            + Number(record?.booking_details?.round_off || 0)).toFixed(2)) :
                                                                        record.booking_details?.payment_details?.total_amount}</div>
                                                                </div>
                                                            </div> :
                                                            <div className="d-flex justify-content-between">
                                                                <div className="ff-poppins-semiBold fs-16">Total</div>

                                                                <div className="d-flex align-items-center gap-2">
                                                                    <button className="paidBtnSP fs-11 ff-poppins-semiBold p-0 m-0">
                                                                        PAID
                                                                    </button>
                                                                    <div className="ff-poppins-semiBold fs-13">
                                                                        Rs.{Number(record?.Billing_details?.cart_amount) + Number(record?.Billing_details?.gst_amount)}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        }
                                                        {paymenttype == '3' ?
                                                            <div className="ff-poppins-bold fs-16 mt-3">
                                                                <div className="d-flex justify-content-between mb-2">
                                                                    <div className="">Advance amount</div>
                                                                    <div className="d-flex justify-content-between me-2 fs-13">
                                                                        <span className="paidBtnSP align-self-center text-center fs-11 ff-poppins-semiBold me-1"> PAID</span>
                                                                        Rs.{paymentdetail.advance_amount}
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex justify-content-between">
                                                                    <div className="">Balance amount</div>
                                                                    <div className="d-flex me-2 ">
                                                                        {paymentdetail.balance_status == 0 ? (
                                                                            <button className="unpaidbtn align-self-center fs-11 ff-poppins-semiBold me-1">
                                                                                UNPAID
                                                                            </button>
                                                                        ) : (
                                                                            <button className="paidBtnSP align-self-center text-center fs-11 ff-poppins-semiBold me-1">
                                                                                PAID
                                                                            </button>
                                                                        )}
                                                                        Rs.{paymentdetail.balance_amount}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            :
                                                            <></>
                                                        }
                                                    </div>
                                                    {
                                                        record.cancel_and_refund_detail?.cancel_status == "1" ?
                                                            <div>
                                                                <div>
                                                                    <h5 className="fs-15 ff-poppins-bold m-0">Cancel Information</h5>
                                                                    <p className="secondary-text-1 fs-12 ff-poppins-regular">{record?.cancel_and_refund_detail?.cancel_description} </p>
                                                                </div>
                                                                <div>
                                                                    <h5 className="fs-15 ff-poppins-bold m-0">Refund Information</h5>
                                                                    <p className="secondary-text-1 fs-12 ff-poppins-regular">{record?.cancel_and_refund_detail?.refund_description} </p>
                                                                </div>

                                                                <div>
                                                                    {
                                                                        record?.cancel_and_refund_detail?.refund_status == "1" || record.payment_method == "loyalty" &&
                                                                        <div>
                                                                            <h5 className="fs-14 ff-poppins-bold m-0">Refund Status</h5>
                                                                            {record.payment_method == "loyalty" ?
                                                                                <p className="secondary-text-1 ff-poppins-regular fs-13">
                                                                                    No refund is applicable for loyalty-redeemed bookings.
                                                                                </p>
                                                                                :
                                                                                <p className="secondary-text-1 ff-poppins-regular fs-13">
                                                                                    {record?.cancel_and_refund_detail?.refund_process_status == "1" ? (
                                                                                        "Refund Processing"
                                                                                    ) : record?.cancel_and_refund_detail?.refund_process_status == "2" ? (
                                                                                        "Refund Complete"
                                                                                    ) :
                                                                                        record?.cancel_and_refund_detail?.refund_process_status == "3" ? (
                                                                                            "Refund Faild"
                                                                                        ) : (
                                                                                            <></>
                                                                                        )}
                                                                                </p>
                                                                            }



                                                                        </div>
                                                                    }</div>
                                                            </div>
                                                            : <></>
                                                    }

                                                    {record.dispute == true ?
                                                        <div>
                                                            <div>
                                                                <h5 className="fs-14 ff-poppins-medium  m-0">Dispute Status</h5>
                                                                <p className="secondary-text-1 p-0 m-0 fs-11 ff-poppins-regular">{record?.dispute_detail?.dispute_status_name} </p>
                                                            </div>
                                                            <div>
                                                                <h5 className="fs-14 ff-poppins-medium m-0">Dispute description</h5>
                                                                <p className="secondary-text-1 fs-11 p-0 m-0 ff-poppins-regular">{record?.dispute_detail?.dispute_description} </p>
                                                            </div>
                                                            <h5 className="fs-14 ff-poppins-medium m-0">Dispute reason</h5>
                                                            <p className="secondary-text-1 text-wrap-break p-0 m-0 fs-11 ff-poppins-regular">
                                                                {record?.dispute_detail?.dispute_reason}
                                                            </p>
                                                        </div> : <></>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="container-fluid mt-4 ps-4 pe-4">
                                <div className="row">
                                    {
                                        (record?.booking_details?.book_que_status == 0 || record?.booking_details?.book_status == 4 || record?.doorstep_que_status == 1) && !appointmentRescheduled && vendor_subscription_status == 0 && bookingstatus != 3 && bookingstatus != 2 ?
                                            <>
                                                <div className="col-12 fs-16 primary-bg rounded   text-white ff-poppins-semiBold text-center p-3" onClick={() => openrescheduleModal(1)}>Reschedule Appointment</div>
                                            </> :
                                            <></>
                                    }

                                    {(storeActiveStep == 0 || bookingstatus == 4 || doorActiveStep == 1 || doorActiveStep == 2 || doorActiveStep == 3) && !appointmentRescheduled && vendor_subscription_status == 1 && bookingstatus != 3 && bookingstatus != 2 ?
                                        <> <div className="col-12 d-flex ps-0 pe-0">
                                            <div className="w-50 primary-bg rounded-3 text-white text-center p-2 me-1 ff-poppins-semiBold fs-16"
                                                onClick={() => openrescheduleModal(1)}>Reschedule</div>

                                            <button aria-controls="offcanvasBottom"
                                                className="w-50 primary-bg rounded-3 text-white text-center p-2 me-1 ff-poppins-semiBold fs-16 border-0" onClick={() => getRefundInfo()} >
                                                Cancel</button>
                                        </div></> : <></>
                                    }

                                    <a href="https://pingle.in/user/refund-policy.php" className="col-12 ff-poppins-regular fs-13 text-center pt-2 pb-2  text-decoration-none text-dark text-center" target="_blank" rel="noopener noreferrer">
                                        <div className="text-center">
                                            Read our <span className="primary-text">Cancellation Policy</span> and <span className="primary-text">Refund Policy</span>
                                        </div>
                                    </a>
                                    {/* <div className="col-12  ff-poppins-semiBold fs-13 text-center pt-4 pb-4">Read our <span className="primary-text">Cancellation policy</span> and <span className="primary-text">Refund Policy</span></div> */}


                                </div>
                            </div>
                            {
                                record.dispute == false ?
                                    <div>
                                        <p className="primary-text text-center fs-14 ff-poppins-medium" onClick={openDisputeModal}>Raise Dispute</p>
                                    </div> : <></>
                            }



                            <div class="offcanvas" tabindex="-1" style={{ width: 390, borderTopLeftRadius: 15, borderTopRightRadius: 15 }} ref={canceldisputeModalRef} >
                                <div class="offcanvas-header">
                                    <h5 class="offcanvas-title ff-poppins-semiBold text-dark fs-16" id="offcanvasBottomLabel">Reason for Dispute</h5>
                                    <button type="button" class="btn-close" onClick={closeDisputeModal}></button>
                                </div>
                                <div class="offcanvas-body small">
                                    <textarea
                                        className="w-100 rounded-2 fs-12 ouline-none ff-poppins-regular custom-input p-2 mb-2"
                                        style={{ height: "100px" }}
                                        placeholder="Enter the reason for your dispute"
                                        value={dispute}
                                        maxLength={120}
                                        onChange={(e) => {
                                            let cleanedValue = e.target.value
                                                .replace(/[^a-zA-Z0-9\s!@%?><()*&_+=$\/\]\-]/g, '')
                                                .replace(/\s+/g, ' ')
                                                .trimStart();
                                            if (cleanedValue.length <= 120) {
                                                setDispute(cleanedValue);
                                            }
                                        }}
                                    ></textarea>

                                    <div className='d-flex justify-content-end ff-poppins-regular mb-2 fs-14'>{dispute?.length ? dispute?.length : 0} / 120</div>

                                    <button className="w-100 primary-bg border-0 text-white ff-poppins-medium py-2 rounded"
                                        onClick={() => {
                                            if (!dispute) {
                                                showToast("Please enter your dispute reason.");
                                            }
                                            else {
                                                const cleaned = dispute.trim().replace(/\s+/g, ' ');
                                                if (cleaned.length < 3 || !/[A-Za-z]/.test(cleaned)) {
                                                    showToast("Please enter atleast more then 3 charater ");
                                                    return;
                                                }
                                                setDispute(cleaned);
                                                raisedispute();
                                            }
                                        }}
                                    >
                                        Raise Dispute
                                    </button>


                                </div>
                            </div>

                            <div class="modal fade backdrop-bg " ref={rescheduleModalRef}  >
                                <div class="modal-dialog modal-dialog-centered customize-modal rounded-4" >
                                    <div class="modal-content mx-4 text-center bg-white">

                                        <div class="modal-body mt-5">
                                            <FaExclamation className="exclamatoryIcon" />
                                        </div>

                                        < div className="p-2 mb-3">
                                            {
                                                rescheduleModeltype == 1 ?
                                                    <>
                                                        <h5 className=" primary-text ff-poppins-bold">Are you sure you want to reschedule ?</h5>
                                                        <p className="fs-14 p-2 secondary-text ff-poppins-semiBold">
                                                            Please note that refund will not be available for future cancellations.
                                                        </p>
                                                    </>
                                                    :
                                                    <h5 className="primary-text ff-poppins-bold fs-14 p-2">{rescheduleMessage} </h5>
                                            }

                                            <button class="primary-bg ff-poppins-bold w-50 mt-2 rounded-pill border border-0 text-light p-1"
                                                onClick={() => { rescheduleModeltype == '1' ? confirmReschedule() : closerescheduleModal() }} >Ok</button>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="offcanvas mainModal rounded-top CancelProduct cancelBtnModalProductPass" style={{ position: 'sticky !important', minHeight: '55px !important' }} ref={cancelrefundModalRef}>
                                <div className="refundContentModal mb-2 refundModal" >

                                    <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
                                        <div className="  mt-3">
                                            <p className="m-0 p-0 fs-14 ff-poppins-bold">Cancel Booking</p>
                                        </div>
                                        <div onClick={() => closecancelrefundModalRef()}  >
                                            <IoCloseSharp />
                                        </div>
                                    </div>
                                    <div className="position-relative"></div>
                                    {
                                        record.payment_method == "loyalty" ?
                                            <p className="m-0 p-0 ff-poppins-regular fs-12" >
                                                Are you sure you want to cancel this booking ? <br></br>

                                                Please note that loyalty points once redeemed will not be refunded or credited back.
                                            </p>
                                            :
                                            <p className="m-0 p-0 ff-poppins-regular fs-12" >
                                                Are you sure you want to cancel the Booking and get refund ? Please read the read the refund policy before clicking the 'confirm' button.
                                            </p>
                                    }



                                    {
                                        record.payment_method == "loyalty" ?


                                            <>
                                                <p className="mt-3 ff-poppins-semiBold fs-13 p-0 m-0" >Refund Status</p>

                                                <p className="ff-poppins-regular fs-12 p-0 m-0 "> No refund is applicable for loyalty-redeemed bookings.</p>

                                            </> :
                                            <>
                                                <p className="mt-3 ff-poppins-semiBold fs-13 p-0 m-0" >Refund amount</p>
                                                {
                                                    refund?.refund_detail?.refund_status == 1 && refund?.refund_detail?.refund_charges_type == "2" ?
                                                        refund?.refund_detail?.refund_charges.map((data) => {
                                                            return (
                                                                <div className="d-flex justify-content-between">
                                                                    <p className="ff-poppins-medium fs-12 p-0 m-0 primary-text">{data.percentage == 0 ? "  No" : data.percentage + "%"} Refund</p>
                                                                    <p className="ff-poppins-regular fs-12 p-0 m-0 ">Cancel {data.time} hrs within booking</p>
                                                                </div>
                                                            )
                                                        })
                                                        : <></>}
                                            </>
                                    }

                                    {
                                        refund?.refund_detail?.refund_status == 0 && record.payment_method != "loyalty" ?
                                            <p className="ff-poppins-regular fs-12 p-0 m-0 ">{refund?.refund_message[0]} </p>
                                            : <></>
                                    }

                                    <p className="m-0 ff-poppins-regular fs-12 text-center" >
                                        Read our <span className="primary-text">cancellation policy</span> and <span className="primary-text">Refund Policy</span>.
                                    </p>
                                </div>
                                <button
                                    className="text-center text-white rescheduleCancelBtnPP ff-poppins-semiBold"
                                    style={{
                                        marginTop: 5,
                                        position: "relative",
                                        padding: "10px 20px",
                                        backgroundColor: "#primary-bg",
                                        color: "white",
                                        border: "0px",
                                        borderRadius: "5px",
                                        height: "40px",
                                        lineHeight: "20px",
                                        verticalAlign: "middle",
                                    }}
                                    onClick={() => {
                                        if (!buttonClicked) {
                                            cancelBooking();
                                        }
                                    }}
                                    disabled={buttonClicked}
                                >
                                    {loading && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                paddingTop: 10,
                                                paddingBottom: 10,
                                            }}
                                        >
                                            <Loading type="spinningBubbles" color="#fff" height={20} width={20} />
                                        </div>
                                    )}
                                    {!loading && 'Confirm'}
                                </button>
                            </div>

                            <div className="offcanvas offcanvas-bottomm customize-modal" style={{ height: 150, borderTopRightRadius: "20px", borderTopLeftRadius: "20px" }} ref={rescheduleRequestModalRef} >
                                {/* <div class="offcanvas-body small bg-light mt-3">
                                    <div className="p-3 text-center"> */}
                                {record?.reschedule_detail?.by == '2' ?
                                    <>
                                        <div className="text-center p-3">
                                            <p className="p-0 m-0 fs-12 ff-poppins-regular">
                                                <span className="primary-text ff-poppins-medium"> {record?.vendor_name}</span>   has requested to reschedule this appointment to{" "}
                                                {new Date(record?.reschedule_detail?.to).toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric", hour: 'numeric', minute: '2-digit', hour12: true, })}.
                                                Are you accepting or rejecting this request ?
                                            </p>

                                            <div class="d-flex justify-content-between mt-3 mb-1">
                                                <button class="ff-poppins-regular fs-13 col-5 p-2 outline-none border-0 text-white  primary-bg rounded-3" onClick={() => acceptRejectReschedule(1)} >
                                                    {
                                                        isLoading ?
                                                            <div className="d-flex justify-content-center">
                                                                <div class="spinner-border mt-1 text-light" role="status" style={{ height: "20px", width: "20px" }} >
                                                                    <span class="visually-hidden">Loading...</span>
                                                                </div>
                                                            </div>
                                                            :
                                                            "Accept"
                                                    }
                                                </button>
                                                <button class="ff-poppins-regular fs-13 col-5 p-2 outline-none border-0 text-white  bg-danger  rounded-3" onClick={() => acceptRejectReschedule(2)} > Reject </button>
                                            </div>
                                        </div>
                                    </> :
                                    record?.reschedule_detail?.by == '1' ?
                                        <>
                                            <p className="p-0 m-0 fs-12 ff-poppins-regular">
                                                You have requested to reschedule this appointment to{" "}
                                                {new Date(record?.reschedule_detail?.to).toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric", hour: 'numeric', minute: '2-digit', hour12: true, })}.
                                                Are you cancelling this request?
                                            </p>

                                            <button class="ff-poppins-semiBold fs-14 col-12 p-2 outline-none border-0 text-white primary-bg mt-4 rounded-3" onClick={() => acceptRejectReschedule(2)} > Request cancel </button>

                                        </>
                                        : ""
                                }
                                {/* </div>
                                </div> */}

                            </div>

                            <div class="modal fade" id="exampleModalConfirm" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref={cancelConfirmModalRef} style={{ backgroundColor: "#fff" }}>
                                <div class="modal-dialog m-0 modal-dialog-centered mainModal px-5">
                                    <div class="modal-content px-4 py-2">
                                        <div class="modal-body d-flex justify-content-center ff-poppins-bold">
                                            Appointment Cancelled
                                        </div>

                                        <img src={AppointmentCancelled} alt="My Image" />

                                        <div class="mb-4 d-flex text-center justify-content-center ff-poppins-regular">
                                            The appointment has been cancelled successfully.
                                        </div>
                                        <button class="text-center text-white rescheduleCancelBtnPP ff-poppins-semiBold" onClick={handleOkClick}>
                                            OK </button>
                                    </div>
                                </div>
                            </div>

                            <div className="offcanvas offcanvas-bottomm rounded-top" style={{ height: 140, width: "390px" }} tabIndex="-1"
                                data-bs-backdrop="true" data-bs-keyboard="true" aria-labelledby="" ref={payBalancerequestModal} >

                                <div className="d-flex justify-content-center">
                                    <div class="modal-content p-2  bg-white">
                                        <div class="">
                                            <h1 class="d-flex ff-poppins-semiBold justify-content-center fs-16 mb-3" id="staticBackdropLabel" >
                                                Pay Balance
                                            </h1>
                                        </div>
                                        <div class="">
                                            <p className="fs-13 ff-poppins-medium text-center">
                                                <span> {record.vendor_name}</span> has requested you to pay the balance
                                                amount <span className="primary-text">  (Rs.{record?.booking_details?.payment_details?.balance_amount})</span>
                                            </p>
                                        </div>
                                        <div class="d-flex justify-content-center gap-3">
                                            <button class="ff-poppins-regular fs-13 PayBtn px-5 py-1 rounded-pill" onClick={payBalance}> Pay </button>
                                            <button class="ff-poppins-regular fs-13 rejectBtn px-5 py-1 rounded-pill" onClick={openCancelBalanceRequestModal}>
                                                Reject
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>


                            <div className={`modal fade`} id="successMoadl" style={{ backgroundColor: "rgba(76 72 72 / 50%)" }} tabIndex="-1" ref={paymentSuccessModalRef}   >
                                <div className="modal-dialog modal-dialog-centered mainModal">
                                    <div className="modal-content rounded-4" style={{ width: "70%" }}>

                                        <div
                                            className="d-flex justify-content-center align-items-center"
                                            style={{ height: "270px", width: "100%" }}
                                        >
                                            <Lottie
                                                animationData={SuccessLotie}
                                                loop={false}
                                                style={{ width: "250px", height: "250px" }}
                                            />
                                        </div>

                                        <div className="ff-poppins-medium fs-14 text-center">
                                            <div className="text-center fw-bold primary-text">
                                                Payment Successful.
                                            </div>
                                            <div className="text-center ff-poppins-medium mt-2">
                                                Redirecting you to your ticket.
                                            </div>
                                            <div className="d-flex justify-content-center">
                                                <div className="col-4 p-2  ouline-none border-none mt-2 mb-3 text-white rounded-4 fs-14 ff-poppins-semiBold primary-bg lottie_ok_btn"
                                                    onClick={handleSuccessOkClick}  >
                                                    OK
                                                </div>
                                            </div>

                                        </div>



                                    </div>
                                </div>

                            </div>

                            <div className="modal fade" tabIndex="-1" aria-hidden="true" style={{ backgroundColor: "rgba(76 72 72 / 50%)" }} ref={cancelBalanceRequestModalRef}   >
                                <div className="modal-dialog modal-dialog-centered"  >
                                    <div className="modal-content p-4" style={{ width: "75%" }}>
                                        <div className="text-center mb-3">
                                            <h1 className="ff-poppins-semiBold fs-14 mb-3" id="staticBackdropLabel">
                                                Cancel Request
                                            </h1>
                                            <p className="fs-13 ff-poppins-regular">
                                                Are you sure want to cancel the payment request?
                                            </p>
                                        </div>

                                        <div className="d-flex justify-content-between">

                                            <button className="ouline-none fs-14 col-4 border border-0 ff-poppins-regular primary-bg rounded-pill text-white" onClick={() => cancelBalanceRequest()} >
                                                {
                                                    isLoading ?
                                                        <div className="d-flex justify-content-center">
                                                            <div class="spinner-border mt-1 text-light" role="status" style={{ height: "20px", width: "20px" }} >
                                                                <span class="visually-hidden">Loading...</span>
                                                            </div>
                                                        </div>
                                                        :
                                                        "Confirm"
                                                }
                                            </button>
                                            <button className="ouline-none fs-14 col-4 border border-0 ff-poppins-regular secondary-bg-1   rounded-pill" onClick={closeCancelBalanceRequestModal} > Cancel </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="offcanvas addOnModel_scroll p-2" style={{ maxHeight: "100%", borderTopLeftRadius: 15, borderTopRightRadius: 15, width: 390 }} tabindex="-1" aria-labelledby="offcanvasBottomLabel" ref={editOrderModalRef} >
                                <div className="mb-2">
                                    <p className="m-0 mb-3 fs-13 ff-poppins-regular mt-2"> <span className="primary-text ff-poppins-semiBold fs-13">{record?.vendor_name} </span> has requested you to edit the booking services.</p>

                                    <div className="mt-2">
                                        <div className="position-relative ">
                                            <div className="position-absolute top-0 start-50 translate-middle bg-white fs-14 ff-poppins-semiBold">Edit Service</div>
                                            <div className="edit_service_Box mt-2">
                                                <div>
                                                    {
                                                        (() => {
                                                            let requested = record?.booking_details?.edit_booking_detail ? JSON.parse(record?.booking_details?.edit_booking_detail?.requested_services) : [];
                                                            return record?.booking_details?.book_service_details.map((proId, index) => {
                                                                requested.includes(proId?.service_id)

                                                                return (
                                                                    <div>
                                                                        <div className="d-flex justify-content-between primary-text ff-poppins-regular fs-13 mt-1 mb-1" key={index}  >
                                                                            <div className="m-0 ff-poppins-regular fs-12">  {proId?.service_name} </div>
                                                                            <div className="d-flex ">

                                                                                {proId?.service_price}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            });
                                                        })()
                                                    }


                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ff-poppins-regular fs-12 mt-2" style={{ backgroundColor: '#fff', position: "sticky", bottom: 0, width: '100%' }}>
                                        <p className="m-0 ff-poppins-semiBold">Reason :</p>
                                        <p className="ms-2 mb-2 ff-poppins-regular">{record?.booking_details?.edit_booking_detail?.request_reason} </p>
                                        <div className="d-flex justify-content-between">
                                            <button className="bg-success text-light ff-poppins-regular p-1 fs-12 border-0  rounded-2 col-5 ms-4" onClick={() => accept_And_EditServices()} >Accept or edit booking</button>
                                            <button className="bg-danger text-light ff-poppins-regular p-1 fs-12 border-0  rounded-2 col-5 me-4" onClick={() => opencancelOrderModal()} >Reject & cancel booking</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="modal fade" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2" style={{ backgroundColor: "rgba(76 72 72 / 50%)" }} tabindex="-1" ref={cancelOrderConfirmModalRef}    >
                                <div class="modal-dialog modal-dialog-centered mainModal p-4">
                                    <div class="modal-content p-3 text-center w-75">
                                        <div class="">
                                            <h1 class="d-flex ff-poppins-semiBold justify-content-center fs-14 mb-3" id="staticBackdropLabel"   >
                                                Cancel Request
                                            </h1>
                                        </div>
                                        <div class="">
                                            <p className="m-0 fs-12 ff-poppins-regular text-center mb-3">
                                                Are you sure want to cancel the edit request and cancel booking ?
                                            </p>
                                        </div>
                                        {
                                            isLoading ?
                                                <div className="d-flex justify-content-center">
                                                    <div class="spinner-border mt-1 primary-text" role="status" style={{ height: "25px", width: "25px" }} >
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                                :
                                                <div className="d-flex justify-content-around">
                                                    <div class="p-1 primary-bg rounded-pill fs-12 col-4 ff-poppins-medium text-white " onClick={() => cancel_EditServices_Request()} >
                                                        Confirm
                                                    </div>
                                                    <div class="p-1 secondary-bg-1 text-dark fs-12 col-4 ff-poppins-medium rounded-pill " onClick={() => closecancelOrderModal()} >
                                                        Cancel
                                                    </div>
                                                </div>
                                        }

                                    </div>
                                </div>
                            </div>


                            <div className={`modal fade`} id="successMoadl"
                                style={{ backgroundColor: "rgba(76 72 72 / 50%)" }}
                                tabIndex="-1"
                                ref={feedbacksuccessModalRef}>

                                <div className="modal-dialog modal-dialog-centered mainModal">
                                    <div className="modal-content rounded-4" style={{ width: "70%" }}>

                                        <div className="d-flex justify-content-center align-items-center"
                                            style={{ height: "270px", width: "100%" }}>
                                            <Lottie
                                                animationData={thankyouLottie}
                                                loop={false}
                                                autoplay={true}
                                                style={{ width: "250px", height: "250px" }}
                                            />
                                        </div>

                                        <div className="mb-3 text-center px-3">
                                            <div className="ff-poppins-semiBold fs-14 secondary-text mb-3">
                                                Thank you for reaching out and providing us with valuable feedback and rating.
                                            </div>

                                            <button
                                                type="button"
                                                className=" col-4 mt-2 mb-3 text-white rounded-4 fs-14 ff-poppins-semiBold primary-bg lottie_ok_btn"
                                                onClick={() => closefeedbacksuccessModal()}>
                                                OK
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="offcanvas offcanvas-bottomm Chooseaddres rounded-2 main"
                                tabIndex="-1" aria-labelledby="offcanvasBottomLabel"
                                ref={instructionsNoteRef} style={{ maxHeight: '48vh', zIndex: 1045 }}>
                                <div className="offcanvas-body small bg-light position-relative">

                                    <div className="d-flex justify-content-between">
                                        <h5 className="ff-poppins-semiBold fs-16 text-dark mt-1">Instructions Note</h5>

                                        {
                                            !pauseicon &&
                                            <div onClick={() => closeinstructionsModal()}>
                                                <IoMdClose />
                                            </div>
                                        }
                                    </div>
                                    <div>
                                        {/* <div className={`w-100 ${!restartRecord ? "primary-border-1" : "secondary-border"} rounded-2  p-1`} style={{ height: "55px" }}>
                                            {restartRecord ? (
                                                <div className="d-flex justify-content-between align-items-center p-1">

                                                    {!pauseicon ?
                                                        <p className="fs-12 ms-1 p-0 m-0 ff-poppins-medium">Click to record instructions</p> :
                                                        <p className="fs-12 ms-1 p-0 m-1 ff-poppins-medium text-danger"> Recording... {formatTime(recordingTime)}</p>
                                                    }

                                                    {!pauseicon ? (
                                                        <div     className="d-flex justify-content-center align-items-center"
                                                        style={{ width: 36, height: 36 }}
                                                            onClick={() => { setPauseicon(true); }}  >
                                                            <AudioRecorder onRecordingComplete={addAudioElement} recorderControls={recorderControls} showVisualizer={true} />
                                                        </div>
                                                    ) : (
                                                        <div onClick={() => { setPauseicon(false); recorderControls.stopRecording(); }} className="fs-18 primary-text me-3 mt-1">
                                                            <FaPause />
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className="d-flex justify-content-between align-items-center ">
                                                    <div onClick={togglePlayAudio} className=" primary-text d-flex ms-3 mt-2">
                                                        <div className="fs-12 mt-2"> {isPlaying ? <FaStop /> : <FaPlay />}</div>
                                                        <p className="fs-14 p-0 m-0 primary-text ms-2 ff-poppins-medium mt-2">Instructions Recorded</p>
                                                    </div>
                                                    <div className="d-flex mt-2">
                                                        <p className="fs-14 p-0 m-0 primary-text ff-poppins-medium mt-2">  {formatTime(playTime)} / {recordingTime == 0 ? '0.00' : formatTime(recordingTime)}</p>
                                                        <span className="ms-2 me-1 fs-20 text-danger" onClick={() => { deleteRecordedAudio(); setRestartRecord(true); }}>
                                                            <MdDeleteOutline />
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </div> */}

                                        <div
                                            className={`w-100 ${!restartRecord ? "primary-border-1" : "secondary-border"
                                                } rounded-2 px-2`}
                                            style={{ height: "55px" }}
                                        >
                                            {restartRecord ? (
                                                /* RECORD MODE */
                                                <div className="d-flex align-items-center justify-content-between h-100">
                                                    {/* Text */}
                                                    <p
                                                        className={`fs-12 m-0 ff-poppins-medium ${pauseicon ? "text-danger" : ""
                                                            }`}
                                                    >
                                                        {pauseicon
                                                            ? `Recording... ${formatTime(recordingTime)}`
                                                            : "Click to record instructions"}
                                                    </p>

                                                    {/* Mic / Pause */}
                                                    <div
                                                        className="d-flex align-items-center justify-content-center"
                                                        style={{ width: 36, height: 36 }}
                                                        onClick={() => {
                                                            if (pauseicon) {
                                                                recorderControls.stopRecording();
                                                            }
                                                            setPauseicon(!pauseicon);
                                                        }}
                                                    >
                                                        {!pauseicon ? (
                                                            <AudioRecorder
                                                                onRecordingComplete={addAudioElement}
                                                                recorderControls={recorderControls}
                                                                showVisualizer={false}
                                                            />
                                                        ) : (
                                                            <FaPause className="fs-18 primary-text" />
                                                        )}
                                                    </div>
                                                </div>
                                            ) : (
                                                /* PLAYBACK MODE */
                                                <div className="d-flex align-items-center justify-content-between h-100">
                                                    {/* Play / Stop */}
                                                    <div
                                                        onClick={togglePlayAudio}
                                                        className="d-flex align-items-center gap-2 primary-text"
                                                    >
                                                        {isPlaying ? <FaStop /> : <FaPlay />}
                                                        <p className="fs-14 m-0 ff-poppins-medium">
                                                            Instructions Recorded
                                                        </p>
                                                    </div>

                                                    {/* Time + Delete */}
                                                    <div className="d-flex align-items-center gap-2">
                                                        <p className="fs-14 m-0 ff-poppins-medium">
                                                            {formatTime(playTime)} /{" "}
                                                            {recordingTime === 0 ? "0.00" : formatTime(recordingTime)}
                                                        </p>

                                                        <span
                                                            className="fs-20 text-danger"
                                                            onClick={() => {
                                                                deleteRecordedAudio();
                                                                setRestartRecord(true);
                                                            }}
                                                        >
                                                            <MdDeleteOutline />
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                    <div>
                                        <h6 className="fs-14 mt-3 ff-poppins-semiBold ">Additional Note</h6>
                                        <textarea
                                            className="textAreaRP ff-poppins-regular fs-13 mb-1 text-dark"
                                            placeholder="Type your instructions here..."
                                            value={consulation}
                                            maxLength={120}
                                            onChange={(e) => {
                                                if (e.target.value.length <= 120) {
                                                    setConsulation(e.target.value);
                                                }
                                            }}
                                        ></textarea>

                                    </div>
                                    <div className='d-flex justify-content-end ff-poppins-regular fs-12 mt-1 mb-1'>{consulation.length} / 120</div>
                                    <button
                                        disabled={pauseicon == true}
                                        className="InstructionsNoteSaveBtn"
                                        onClick={() => { handleSendInstructions(1); setInstructionIsLoading(true) }}>
                                        {instructionisLoading ? <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"  ></span>
                                            <span className="visually-hidden">Loading...</span>
                                        </> : 'Save'}
                                    </button  >
                                </div>
                            </div>

                        </div >

                        {isModalOpen && <div className="modal-backdrop fade show"   ></div>}
                        {isinstructionModalOpen && <div className="modal-backdrop fade show"   ></div>}

                    </>
                    :
                    <div className='d-flex justify-content-center mt-5'>
                        <div >
                            <Skeleton height={40} width={320} style={{ marginBottom: "10px" }} />
                            <Skeleton height={250} width={320} style={{ marginBottom: "20px" }} />
                            {Array.from({ length: 5 }).map((_, i) => (
                                <div key={i} style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
                                    <Skeleton height={90} width={90} style={{ borderRadius: "12px" }} />
                                    <div style={{ marginLeft: "20px" }}>
                                        <Skeleton height={30} width={180} style={{ marginBottom: "5px" }} />
                                        <Skeleton height={20} width={220} style={{ marginBottom: "5px" }} />
                                        <Skeleton height={20} width={220} />
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>

            }
        </>

    );
};

export default UserBookingDetails;



